
export const translations = {
 en: {
 // Header
 business: "Business",
 personal: "Personal",
 signup: "Sign up",
 login: "Login",
 
 // Navigation
 solutions: "Solutions",
 industries: "Industries",
 company: "Company",
 joinWaitlist: "Sign up free",
 
 // Solutions Menu
 paymentSolutions: "Payment Solutions",
 crossBorderPayments: "Cross-Border Payments",
 freelancerPayments: "Freelancer Payments",
 bulkPayments: "Bulk Payments",
 apiIntegration: "API Integration",
 mainPages: "Main Pages",
 allSolutions: "All Solutions",
 features: "Features",
 pricing: "Pricing",
 
 // Industries Menu
 serviceIndustries: "Service Industries",
 freelancerPlatforms: "Freelancer Platforms",
 recruitmentAgencies: "Recruitment Agencies",
 consultingFirms: "Consulting Firms",
 techAndCreative: "Tech & Creative",
 techStartups: "Tech Startups",
 creativeStudios: "Creative Studios",
 ecommerce: "E-commerce",
 overview: "Overview",
 allIndustries: "All Industries",
 
 // Company Menu
 about: "About",
 aboutUs: "About Us",
 whyChooseFlip: "Why Choose Flip",
 contactUs: "Contact Us",
 resources: "Resources",
 blog: "Blog",
 resourceHub: "Resource Hub",
 
 // Hero Section
 heroTitle: "Send USDC Payouts Globally Using Just a Phone Number",
 heroSubtitle: "Save On Hidden FX And Transaction Fees",
 getStarted: "Get started free",
 ctaSubtext: "Setup in 5 minutes",
 heroHeadline: "Pay Freelancers & Contractors With USDC",
 
 // Value Proposition Bullets
 fasterPayments: "Send USDC payouts globally using just a phone number",
 saveOnFees: "Save up to 85% on banking fees", 
 secureTransparent: "Instant, secure, and simple — freelancers receive payments directly and have full custody of their funds",
 builtForBusiness: "Built for freelancers, startups, and remote teams",
 
 // Non-Custodial Messaging
 nonCustodialBadge: "Non-Custodial",
 neverHoldFunds: "We never hold your freelancers' funds",
 trueOwnership: "True ownership - freelancers control their keys",
 zeroCounterpartyRisk: "Zero counterparty risk",
 selfCustodySecurity: "Self-Custody Security",
 fundsFlowDirectly: "Funds flow directly to recipients",
 noSinglePointFailure: "No single point of failure",
 
 // Key Benefits
 sendToPhone: "Instant Global Payouts",
 sendToPhoneDesc: "Pay freelancers worldwide in minutes, not days.",
 instantSettlements: "Save Up to 85% on Fees", 
 instantSettlementsDesc: "Stablecoins eliminate bank charges.",
 bankGradeSecurity: "Non-Custodial Security",
 bankGradeSecurityDesc: "Freelancers own their keys. We never hold funds.",
 fastLowCost: "24/7 Borderless Payments",
 fastLowCostDesc: "Real-time payments that never sleep.",
 
 // Use Cases Section (legacy keys kept for other pages)

 freelancerPaymentsUseCase: "Freelancer Payments",
 customerRefunds: "Customer Refunds",
 vendorPayments: "Vendor Payments",
 expenseReimbursements: "Expense Reimbursements",
 learnMore: "Learn More",
 
 // Trust & Security Section
 completePaymentControl: "Complete Payment Control. Zero Business Risk.",
 nonCustodialBusinessDesc: "Non-custodial technology that eliminates counterparty risk and ensures business continuity",
 whyNonCustodialMatters: "Why Non-Custodial Matters for Business",
 custodialPaymentRisk: "Custodial Payment Risk",
 flipNonCustodialAdvantage: "Flip's Non-Custodial Advantage",
 completePaymentControlRetained: "Complete payment control retained",
 zeroOperationalDisruption: "Zero operational disruption risk",
 guaranteedBusinessContinuity: "Guaranteed business continuity",
 enhancedRegulatoryCompliance: "Streamlined documentation",
 thirdPartiesControlFunds: "Third parties control your funds",
 accountFreezesDisrupt: "Account freezes disrupt operations",
 businessContinuityAtRisk: "Business continuity at risk",
 regulatoryComplications: "Manual reconciliation headaches",
 
 // Waitlist Form
 joinWaitlistTitle: "Create Your Account",
 waitlistTitle: "Start Saving on Global Payments",
 waitlistSubtitle: "Join 500+ companies switching to USDC Contractor Payouts",
 waitlistSuccessTitle: "You're all set!",
 waitlistSuccessDescription: "Your account is ready. Start sending payments today.",
 companyInformation: "Company Information",
 contactNameField: "Contact Name",
 emailAddress: "Email Address",
 phoneNumber: "Phone Number",
 businessInformation: "Business Information",
 primaryUseCase: "Primary Use Case",
 expectedMonthlyVolume: "Expected Monthly Volume",
 uaeExchangeAccount: "Crypto Exchange Account",
 exchangeAccountQuestion: "Do you already have a registered crypto exchange account?",
 interestedServices: "Interested Services",
 additionalInformation: "Additional Information",
 cancel: "Cancel",
 submitting: "Submitting...",
 
 // Early Access Inline CTA
 earlyAccessTitle: "Start sending contractor payouts from the UAE",
 earlyAccessSubtitle: "Save on FX spread & reduce ops time on overseas contractor payouts.",
 earlyAccessPositioning: "Batch contractor payouts powered by USDC settlement under the hood, delivering USDC to contractors' phone numbers via mobile number — no wallet address, contractors don't need crypto.",
 earlyAccessEmailLabel: "Work email",
 earlyAccessEmailPlaceholder: "you@company.com",
 earlyAccessCompanyLabel: "Company name (optional)",
 earlyAccessCompanyPlaceholder: "Your company",
 earlyAccessVolumeLabel: "Monthly volume AED (optional)",
 earlyAccessVolumePlaceholder: "Select range",
 earlyAccessCorridorsLabel: "Main corridors (optional)",
 earlyAccessPhoneLabel: "WhatsApp/mobile (optional)",
 earlyAccessPhonePlaceholder: "+971...",
 earlyAccessCTAButton: "Sign up free",
 earlyAccessSubmitting: "Submitting...",
 earlyAccessTrust1: "Contractors receive USDC to their phone number",
 earlyAccessTrust2: "USDC settlement under the hood",
 earlyAccessTrust3: "",
 earlyAccessSocialProof: "Some UAE teams save ~AED {amount}/year when they batch contractor payouts with USDC via Flip.",
 earlyAccessSuccessTitle: "You're all set!",
 earlyAccessSuccessMessage: "Your account is ready. Start sending contractor payouts today.",
 earlyAccessSuccess: "Account created!",
 earlyAccessSuccessDesc: "You're ready to start sending payments.",
 earlyAccessError: "Submission failed",
 earlyAccessErrorDesc: "Please try again or contact us directly.",
 earlyAccessInvalidEmail: "Invalid email",
 earlyAccessInvalidEmailDesc: "Please enter a valid work email address.",
 earlyAccessAlreadySubmitted: "Already registered",
 earlyAccessAlreadySubmittedDesc: "You already have an account. Log in to get started!",
 earlyAccessEstimatorToggle: "Estimate potential savings (30 sec)",
 earlyAccessEstVolume: "Monthly payout volume AED",
 earlyAccessEstMethod: "Current method",
 earlyAccessEstMethodPlaceholder: "Select method",
 earlyAccessEstPayouts: "Payouts per month",
 earlyAccessEstSpreadQuestion: "Know your FX spread?",
 earlyAccessEstYes: "Yes",
 earlyAccessEstCalculate: "Calculate estimate",
 earlyAccessEstCurrentCost: "Est. current monthly cost",
 earlyAccessEstMonthlySavings: "Potential monthly savings",
 earlyAccessEstAnnualSavings: "Annual potential",
 earlyAccessEstMethodology: "How we calculated this",
 earlyAccessEstMethodology1: "FX spread based on typical ranges for your method",
 earlyAccessEstMethodology2: "Transaction fees estimated per payout",
 earlyAccessEstMethodology3: "Ops time: ~10 min/payout at AED 150/hr",
 earlyAccessEstMethodology4: "Flip savings: 0.8-2% spread improvement + fee/ops reduction",
 earlyAccessEstDisclaimer: "These are estimates only. Actual savings depend on your specific situation.",
 earlyAccessEstCTAPrompt: "Ready to get started? Sign up free above.",
 
 // How It Works
 howItWorks: "How It Works",
 step1Title: "Fund in USDC",
 step1Desc: "Top up via bank transfer or card.",
 step2Title: "Process Payment",
 step2Desc: "We settle in stablecoins through trusted partners.",
 step3Title: "Direct to Wallet",
 step3Desc: "Freelancers receive in their non-custodial wallet.",
 
 // Why Choose Flip
 simplicityTitle: "No Crypto Skills Needed",
 simplicityDesc: "You pay in USDC, they receive instantly with full control.",
 builtForBusinessTitle: "Built for Business",
 builtForBusinessDesc: "Local support with global reach.",
 empowerRecipientsTitle: "True Financial Freedom",
 empowerRecipientsDesc: "Freelancers own their funds completely - no intermediaries.",
 costEffectiveTitle: "Transparent Fees",
 costEffectiveDesc: "Save up to 85% vs wire transfers. No hidden costs.",
 
 // Trust & Security Section - Updated Branding
 trustSecurityTitle: "True Ownership. Zero Risk.",
 trustSecuritySubtitle: "Give your freelancers complete control while eliminating your payment risks",
 trustPoint1: "Business Continuity Guaranteed",
 trustPoint1Desc: "Your operations never depend on our service availability - freelancers always control their funds",
 trustPoint2: "No Payment Restrictions",
 trustPoint2Desc: "Freedom from traditional banking limitations and account freezing risks",
 trustPoint3: "Complete Risk Elimination",
 trustPoint3Desc: "Zero counterparty risk means your business is never exposed to payment processor failures",
 
 // Contact Page
 contactPageTitle: "Let's discuss your",
 contactPageSubtitle: " freelancer payment challenges",
 contactPageDescription: "Book a demo to see how Flip for Business transforms how companies pay international freelancers with non-custodial stablecoins using just phone numbers—no crypto knowledge required.",
 bookDemo: "Book a Demo",
 companyName: "Company Name",
 companyNamePlaceholder: "Your company",
 contactName: "Contact Name",
 contactNamePlaceholder: "Your name",
 email: "Email",
 emailPlaceholder: "your@email.com",
 phone: "Phone",
 phonePlaceholder: "+1 XXX XXX XXXX",
 businessType: "Business Type",
 businessTypePlaceholder: "Select your business type",
 monthlyVolume: "Monthly Freelancer Payment Volume",
 monthlyVolumePlaceholder: "Select volume range",
 message: "Tell us about your freelancer payment challenges",
 messagePlaceholder: "Share your current challenges with paying international freelancers, transfer fees, delays, or complexity...",
 required: "*",
 bookDemoButton: "Book Demo",
 scheduling: "Scheduling...",
 
 // Business Types
 freelancerPlatform: "Freelancer Platform",
 recruitment: "Recruitment Agency",
 creativeMarketing: "Creative/Marketing Agency",
 techStartup: "Tech Startup",
 consulting: "Consulting Firm",
 otherBusiness: "Other Business",
 
 // Volume Ranges
 volume0to10k: "$0 - $10,000",
 volume10kto50k: "$10,000 - $50,000",
 volume50kto200k: "$50,000 - $200,000",
 volume200kto500k: "$200,000 - $500,000",
 volume500kplus: "$500,000+",
 
 // Contact Info
 getInTouch: "Get in Touch",
 emailContact: "business@theflip.app",
 emailDesc: "Expert support for businesses",
 phoneContact: "+1 XXX XXX XXXX",
 phoneDesc: "Business hours support",
 officeLocation: "Global Operations",
 officeCountry: "Worldwide",
 
 // Schedule Demo (legacy - kept for compatibility)
 scheduleDemo: "Cost Savings Estimate",
 scheduleDemoDesc: "See how businesses are revolutionizing freelancer payments with non-custodial stablecoins—no crypto complexity required.",
 demoFeature1: "• 30-minute live demonstration",
 demoFeature2: "• Non-custodial payment walkthrough",
 demoFeature3: "• Cost savings analysis for your business",
 demoFeature4: "• Q&A with our payment experts",
 scheduleDemoButton: "Schedule Demo",
 
 // Cost Savings Estimate Calculator
 costSavingsEstimate: "Cost Savings Estimate",
 costEstimateStep1Desc: "Tell us about your current overseas contractor payments",
 costEstimateStep2Desc: "Enter your details to see your personalized estimate",
 costEstimateStep3Desc: "Here's what you could be saving",
 monthlyPayoutVolume: "Monthly overseas contractor payout volume",
 primaryCorridor: "Primary payout corridor",
 currentPayoutMethod: "Current payout method",
 continueButton: "Continue",
 workEmail: "Work email",
 roleTitle: "Role/title (optional)",
 seeMyEstimate: "See my estimate",
 yourPotentialSavings: "Your potential savings range",
 estimatedMonthlyLeakage: "Estimated monthly leakage",
 estimatedAnnualLeakage: "Estimated annual leakage",
 potentialSavingsRate: "Potential avoidable cost",
 ofPayoutVolume: "of payout volume",
 savingsDisclaimer: "Indicative ranges based on typical total cost (fees + FX spread). Actuals vary by corridor, provider, and recipient bank deductions.",
 requestUaeAccess: "Sign up free",
 runAnotherEstimate: "Run another estimate",
 atLeast: "at least",
 backButton: "Back",
 selectVolume: "Select volume range",
 selectCorridor: "Select corridor",
 selectMethod: "Select method",
 selectRole: "Select role",
 invalidEmail: "Please enter a valid email address",
 
 // Volume buckets
 volumeUnder5k: "Under $5k",
 volume5kTo20k: "$5k–$20k",
 volume20kTo50k: "$20k–$50k",
 volume50kTo100k: "$50k–$100k",
 volume100kPlus: "$100k+",
 
 // Corridors
 corridorIndia: "India",
 corridorPakistan: "Pakistan",
 corridorPhilippines: "Philippines",
 corridorUkEurope: "UK/Europe",
 corridorOther: "Other",
 
 // Payment Methods
 methodBankWire: "Bank wire/SWIFT",
 methodWise: "Wise",
 methodPayoneer: "Payoneer",
 methodPaypal: "PayPal",
 methodOther: "Other",
 
 // Roles
 roleFounder: "Founder/CEO",
 roleFinance: "Finance",
 roleOps: "Operations",
 roleOther: "Other",
 
 // Toast Messages
 missingInformation: "Missing Information",
 fillRequiredFields: "Please fill in company name, contact name, and email.",
 demoRequestSubmitted: "Demo Request Submitted!",
 demoRequestSuccess: "Thank you for your interest! We will contact you soon to schedule your demo.",
 submissionFailed: "Submission Failed",
 submissionError: "There was an error submitting your request. Please try again.",
 pleaseFillForm: "Please Fill Form First",
 fillFormFirst: "Please fill in the demo request form above before scheduling.",
 demoScheduled: "Demo Scheduled!",
 demoScheduleSuccess: "We've received your request and will contact you to confirm your demo time.",
 schedulingFailed: "Scheduling Failed",
 schedulingError: "There was an error scheduling your demo. Please try again.",
 
 // Footer
 beFirstToExperience: "The Future of Non-Custodial Business Payments",
 joinBusinesses: "Join 1,000+ businesses already sending payments globally. Free to create an account.",
 joinWaitlistNow: "Sign up free",
 businessesWaiting: "1,247 businesses signed up",
 
 // Footer Business Solutions
 businessSolutions: "Business Solutions",
 sendCryptoPayments: "Send Non-Custodial Payments",
 bulkPaymentProcessing: "Bulk Payment Processing",
 vendorSettlements: "Vendor Settlements",
 
 // Footer Resources
 apiDocumentation: "API Documentation",
 faqSupport: "FAQ & Support",
 complianceGuide: "Documentation Guide",
 
 // Footer Contact
 businessHours: "Support",
 supportAvailable: "24/7 Support Available",
 
 // Footer Legal
 allRightsReserved: "All rights reserved.",
 privacyPolicy: "Privacy Policy",
 termsOfService: "Terms of Service",
 language: "Language:",
 
 // Trust markers
 trusted: "Over 1M downloads", 
 processed: "$3M+ processed",
 countries: "180+ countries",
 zeroIncidents: "Zero security incidents",
 trustedPlatform: "Trusted Platform",
 bankGradeSec: "Non-Custodial Security • Zero Custody Risk • Launching Q2 2026",
 globalOperations: "Global Operations",
 
 // Enhanced FAQ
 nonCustodialFaq1: "Do you hold freelancers' funds?",
 nonCustodialFaq1Answer: "No, absolutely not. All funds go directly to freelancers' non-custodial wallets. We never hold, custody, or have access to their funds. Freelancers maintain complete control through their private keys.",
 nonCustodialFaq2: "What if Flip goes down?",
 nonCustodialFaq2Answer: "Freelancers always control their funds independently. Since we use non-custodial wallets, their funds are never at risk if our service goes offline. They own their private keys and can access their funds anytime.",
 nonCustodialFaq3: "Who has access to the money?",
 nonCustodialFaq3Answer: "Only the freelancer with their private keys has access. This is the power of non-custodial technology - true ownership with zero counterparty risk.",
 nonCustodialFaq4: "How is this different from banks or PayPal?",
 nonCustodialFaq4Answer: "Traditional services hold your money and can freeze accounts. With Flip's non-custodial approach, freelancers have true ownership - no one can freeze or restrict their funds.",
 
 // FAQ Section
 frequentlyAskedQuestions: "Frequently Asked Questions",
 faqSubtitle: "Everything you need to know about non-custodial freelancer payments",
 faqDescription: "Get answers to common questions about paying global freelancers with non-custodial stablecoins",
 stillHaveQuestions: "Still have questions about non-custodial payments? We're here to help.",
 contactSupport: "Contact Support",
 
 // FAQ Questions and Answers
 faq1Question: "What is Flip for Business?",
 faq1Answer: "Flip for Business helps companies pay international freelancers in non-custodial stablecoins. Add your freelancers using their phone numbers, set payout amounts, and we'll handle the rest—one simple dashboard, one local bank transfer, many happy freelancers with full control of their funds.",
 faq5Question: "How is Flip different from just paying with an exchange?",
 faq5Answer: "Most exchanges require you to collect wallet addresses, handle network selection, and manage payouts manually. One transaction at a time. Flip for Business automates the process with non-custodial delivery, removes many of the pitfalls, and provides a seamless experience for both your company and your freelancers.",
 faq6Question: "Do freelancers need crypto knowledge?",
 faq6Answer: "No! Your freelancers don't need to worry about wallet setup, networks, or finding the right blockchain addresses. They simply use their phone number and receive funds in their secure, non-custodial wallet! There's no crypto learning curve required, but they maintain full ownership.",
 faq7Question: "How does the payment process work?",
 faq7Answer: "It's simple: 1) Add freelancers by entering phone numbers and amounts, 2) Get a single total from Flip for all payouts, 3) Select your preferred exchange and make one local bank transfer, 4) Each freelancer receives stablecoins in their non-custodial Flip App wallet instantly - they own the keys, not us.",
 faq8Question: "What exchanges do you support?",
 faq8Answer: "We support major exchanges and are continuously expanding our partnerships to give you more non-custodial payment options.",
 faq9Question: "Can I pay multiple freelancers at once?",
 faq9Answer: "Yes! Bulk payments are made easy with Flip. Pay one or many freelancers, each with unique amounts, in just a few clicks to their individual non-custodial wallets. All payments are consolidated into one amount for your convenience.",
 faq10Question: "What are the benefits over traditional payments?",
 faq10Answer: "Speed, cost, security, and true ownership. Traditional international payments can take 5-7 days, cost 3-8% in fees, and involve custody risk. With Flip's non-custodial approach, payments are delivered in minutes, fees are typically under 2%, and freelancers have complete control of their funds.",
 faq11Question: "How do freelancers receive their payments?",
 faq11Answer: "Freelancers receive their stablecoins directly in their intuitive, simple, and secure non-custodial Flip App wallet. They own their private keys - not us. Just their phone number and complete financial sovereignty.",
 
 // Testimonials Section
 trustedWorldwide: "Trusted Worldwide",
 whatCustomersSay: "What Our Customers Say",
 testimonial1Quote: "Flip cut our freelancer payment costs by 70%. Our designers in Ukraine and India get paid in 10 minutes instead of 5-7 days.",
 testimonial1Author: "Ahmad H.",
 testimonial1Position: "CFO",
 testimonial1Company: "Creative Co.",
 testimonial2Quote: "Phone-number payments are genius. No crypto wallets needed. If you know a phone number, you can pay them instantly.",
 testimonial2Author: "Sara M.",
 testimonial2Position: "Operations Manager",
 testimonial2Company: "TechSolutions LLC",
 testimonial3Quote: "Bank-grade security with crypto speed. Our international vendor payments are same-day instead of waiting a week.",
 testimonial3Author: "Mohammed K.",
 testimonial3Position: "Finance Director",
 testimonial3Company: "Global Innovations",
 
 // Footer additional
 cryptoPaymentsSimple: "Crypto payments as simple as sending a text. Secure and built for business.",
 
 // UAE Hub - English
 uaeHeroTitle: "Pay overseas contractors from the UAE — by phone number",
 uaeHeroSubtitle: "Contractors receive USDC to their phone number. USDC under the hood (optional). ",
 uaePrimaryCta: "Cost Savings Estimate",
 uaeSecondaryCta: "Sign up free",
 uaeHowItWorksTitle: "How It Works",
 uaeHowItWorksStep1Title: "Add Contractor",
 uaeHowItWorksStep1Desc: "Enter their phone number and amount. No bank details needed.",
 uaeHowItWorksStep2Title: "We Handle Conversion",
 uaeHowItWorksStep2Desc: "We convert AED to USDC then to their USDC.",
 uaeHowItWorksStep3Title: "They Receive Funds",
 uaeHowItWorksStep3Desc: "Money arrives to their phone number in USDC.",
 uaeWhyOverpayTitle: "Why Teams Overpay",
 uaeWhyOverpayDesc: "When you send money internationally, your real cost is fees + FX spread. Most banks and providers add a hidden margin on the exchange rate — typically 1-4% — on top of their stated fees.",
 uaePopularCorridors: "Popular Corridors",
 uaeResourcesTitle: "Resources",
 uaeFaqPreview: "Frequently Asked Questions",
 uaeTrustCopy: "Indicative estimates based on typical total costs (fees + FX spread). Actuals vary by corridor/provider.",
 
 // UAE Resources Hub - English
 uaeResourcesHubTitle: "UAE Resources",
 uaeResourcesHubDesc: "Tools and guides to help you understand and reduce your overseas payment costs",
 uaeFxLeakCalculator: "FX Leak Calculator",
 uaeFxLeakCalculatorDesc: "Discover how much you're losing to hidden FX margin",
 uaePayoutChecklist: "Contractor Payout Checklist",
 uaePayoutChecklistDesc: "Step-by-step checklist to optimize your contractor payments",
 uaeBankDeductions: "Bank Deductions Explainer",
 uaeBankDeductionsDesc: "Understand why recipients receive less than you sent",
 uaeCorridorGuides: "Corridor Guides",
 uaeCorridorGuidesDesc: "Detailed guides for sending money to specific countries",
 uaeFaqLink: "FAQ",
 uaeFaqLinkDesc: "Answers to common questions about contractor payments",
 
 // FX Leak Checker - English
 fxLeakTitle: "FX Leak Checker",
 fxLeakSubtitle: "Discover how much you're losing to hidden FX margin on your international transfers",
 fxLeakAedSent: "AED Sent",
 fxLeakAedSentPlaceholder: "e.g. 10,000",
 fxLeakAmountReceived: "Amount Received (foreign currency)",
 fxLeakAmountReceivedPlaceholder: "e.g. 2,500",
 fxLeakCurrency: "Recipient Currency",
 fxLeakMidMarketRate: "Mid-Market Rate",
 fxLeakMidMarketRatePlaceholder: "e.g. 4.10",
 fxLeakMidMarketRateHelp: "Google 'AED to [currency]' for the current rate",
 fxLeakVisibleFee: "Visible Fee (AED, optional)",
 fxLeakVisibleFeePlaceholder: "e.g. 25",
 fxLeakCalculate: "Calculate My Leak",
 fxLeakResults: "Your Results",
 fxLeakEffectiveRate: "Your Effective Rate",
 fxLeakImpliedSpread: "Implied Spread",
 fxLeakHiddenCost: "Hidden FX Cost",
 fxLeakAllInCost: "All-In Cost",
 fxLeakSaveResults: "Save My Results",
 fxLeakEmailRequired: "Enter your email to save results",
 fxLeakCompanyRequired: "Company Name",
 fxLeakDisclaimer: "This calculator provides indicative estimates. Actual results may vary based on transfer timing, intermediary bank fees, and other factors.",
 
 // Cost Savings Estimate - English
 costEstimateTitle: "Cost Savings Estimate",
 costEstimateSubtitle: "Discover how much you could save on overseas contractor payments",
 
 // Corridor Pages - English
 corridorIndiaTitle: "Send Money from UAE to India",
 corridorIndiaDesc: "Complete guide to paying contractors in India from the UAE",
 corridorPakistanTitle: "Send Money from UAE to Pakistan",
 corridorPakistanDesc: "Complete guide to paying contractors in Pakistan from the UAE",
 corridorPhilippinesTitle: "Send Money from UAE to Philippines",
 corridorPhilippinesDesc: "Complete guide to paying contractors in the Philippines from the UAE",
 corridorUkEuropeTitle: "Send Money from UAE to UK/Europe",
 corridorUkEuropeDesc: "Complete guide to paying contractors in the UK and Europe from the UAE",
 corridorCommonMethods: "Common Methods",
 corridorCostDrivers: "Cost Drivers",
 corridorVerifyRate: "How to Verify Your Rate",
 corridorMiniChecklist: "Quick Checklist",
 
 // FAQ Page - English
 uaeFaqTitle: "UAE Payments FAQ",
 uaeFaqSubtitle: "Answers to 25 common questions about paying overseas contractors from the UAE",
 
 // CTA Component - English
 uaeCtaTitle: "Ready to Reduce Your Payment Costs?",
 uaeCtaDescription: "See how much you could save on overseas contractor payments from the UAE.",
 
 // Resource Download Gate - English
 uaeDownloadErrorEmail: "Please enter a valid email address",
 uaeDownloadErrorCompanyName: "Please enter your company name",
 uaeDownloadSuccess: "Download Ready!",
 uaeDownloadSuccessDescription: "Your download is starting now.",
 uaeDownloadButton: "Download Resource",
 uaeDownloadTitle: "Get Your Free Resource",
 uaeDownloadDescription: "Enter your details to download {resource}",
 uaeDownloadEmail: "Work Email",
 uaeDownloadCompanyName: "Company Name",
 uaeDownloadCancel: "Cancel",
 uaeDownloadSubmitting: "Processing...",
 uaeDownloadNow: "Download Now",
 uaeDownloadErrorSubmitFailed: "Download Failed",
 uaeDownloadErrorTryAgain: "Please try again in a moment.",
 
 // UAE Corridor Card
 uaeCorridorFees: "Fees",
 uaeCorridorSpread: "Spread",
 uaeCorridorTime: "Time",
 uaeCorridorLearnMore: "Learn More",
 
 // WhyFlip Page - English
 whyFlipTitle: "When payouts break, everything downstream breaks too",
 whyFlipDesc: "Delays create churn. Manual fixes create errors. Flip is built around the payout workflow, not the bank workflow.",
 whyFlipVsTraditional: "Flip vs Traditional Payments",
 whyFlipSeeForYourself: "See the difference for yourself",
 whyFlipFeature: "Feature",
 whyFlipTraditionalBanks: "Traditional Banks",
 whyFlipSetupTime: "Setup Time",
 whyFlip2to4Weeks: "2-4 weeks",
 whyFlip5Minutes: "5 minutes",
 whyFlipInternationalFees: "International Fees",
 whyFlip3to7Percent: "3-7% + fixed fees",
 whyFlipLessThan25: "Fees vary by corridor",
 whyFlipSettlementTime: "Settlement Time",
 whyFlip3to5Days: "3-5 business days",
 whyFlipInstant: "Timelines vary by corridor",
 whyFlipWeekendProcessing: "Weekend Processing",
 whyFlipNo: "No",
 whyFlip247: "Available 24/7",
 whyFlipCompliance: "Documentation",
 whyFlipComplexDocs: "Complex paperwork",
 whyFlipUaeRegulated: "Streamlined process",
 whyFlipAdvantage: "The Flip Advantage",
 whyFlipEverythingYouNeed: "Everything you need, nothing you don't",
 whyFlipBenefit1: "Less back-and-forth on payment details",
 whyFlipBenefit2: "Cleaner ops with fewer manual steps",
 whyFlipBenefit3: "Better visibility into payment status",
 whyFlipBenefit4: "No hidden fees or surprises",
 whyFlipBenefit5: "Built for UAE use cases",
 whyFlipBenefit6: "Phone number payments",
 whyFlipTrustedByBusinesses: "Trusted by growing businesses",
 whyFlipCustomerSatisfaction: "Customer satisfaction",
 whyFlipProcessedMonthly: "Processed monthly",
 whyFlipActiveBusinesses: "Active businesses",
 whyFlipTestimonial: "Flip changed how we pay our international team. What used to take a week now happens much faster, and we've significantly reduced our payment costs.",
 whyFlipTestimonialAuthor: "Sarah Ahmed",
 whyFlipTestimonialPosition: "CEO, TechStartup Dubai",

 
 // Industry Pages - Common
 industryBuiltFor: "Built for",
 industryGetStarted: "Get Started Today",
 industryScheduleDemo: "Schedule Demo",
 industryLearnMore: "Learn More",
 industryChallenges: "Challenges",
 industrySolutions: "Solutions",
 industryHowWeHelp: "How We Help",
 industryReadyToStart: "Ready to Start?",
 
 // Recruitment Agencies Page - English
 recruitmentBuiltFor: "Recruitment Agencies",
 recruitmentHeroTitle: "Pay Contractors",
 recruitmentHeroTitleHighlight: "Worldwide",
 recruitmentHeroDesc: "Flip makes it simple for recruitment agencies to pay contractors, remote workers, and candidates globally. No complex setup – just phone numbers and instant payments.",
 recruitmentStartPaying: "Start Paying Contractors",
 recruitmentSeeUseCases: "See Recruitment Use Cases",
 recruitmentAgenciesCount: "Recruitment Agencies",
 recruitmentFasterPayment: "Faster Payment Processing",
 recruitmentAvgPaymentTime: "Average Payment Time",
 recruitmentCountriesSupported: "Countries Supported",
 recruitmentPaymentProcessing: "Payment Availability",
 recruitmentChallengesTitle: "Recruitment Payment Challenges",
 recruitmentChallengesDesc: "Why traditional payments don't work for recruitment agencies",
 recruitmentChallenge1Title: "International Contractor Payments",
 recruitmentChallenge1Desc: "Recruitment agencies struggle with paying contractors and remote workers across multiple countries with traditional banking.",
 recruitmentChallenge2Title: "Slow Payment Processing",
 recruitmentChallenge2Desc: "Traditional wire transfers take days to process, creating cash flow issues for contractors and candidates.",
 recruitmentChallenge3Title: "High Transaction Costs",
 recruitmentChallenge3Desc: "International payment fees can eat up to 10% of contractor compensation, reducing profitability.",
 recruitmentSolutionsTitle: "How Flip Empowers Recruitment Agencies",
 recruitmentSolutionsDesc: "Streamlined payments for global talent acquisition",
 recruitmentSolution1Title: "Contractor Payment System",
 recruitmentSolution1Desc: "Pay contractors and remote workers worldwide instantly using just their phone number - no crypto wallets needed.",
 recruitmentSolution1Benefit: "Instant onboarding for new contractors",
 recruitmentSolution2Title: "Bulk Payment Processing",
 recruitmentSolution2Desc: "Process multiple contractor payments simultaneously with competitive rates and transparent pricing.",
 recruitmentSolution2Benefit: "Save hours on payment administration",
 recruitmentSolution3Title: "Documentation Ready",
 recruitmentSolution3Desc: "Built-in documentation features for recruitment agencies including audit trails and exportable reports.",
 recruitmentSolution3Benefit: "Audit-ready documentation",
 recruitmentCtaTitle: "Ready to Transform Contractor Payments?",
 recruitmentCtaDesc: "Join recruitment agencies already using Flip to pay talent worldwide",
 recruitmentGetStartedToday: "Get Started Today",
 
 // Consulting Page - English
 consultingBuiltFor: "Consulting Firms",
 consultingHeroTitle: "Pay Expert Consultants",
 consultingHeroTitleHighlight: "Globally",
 consultingHeroDesc: "Flip makes it simple for consulting firms to pay independent consultants, subject matter experts, and advisors worldwide. Professional payments without the complexity.",
 consultingStartPayingConsultants: "Start Paying Consultants",
 consultingSeeUseCases: "See Consulting Use Cases",
 consultingFirmsCount: "Consulting Firms",
 consultingFasterPayment: "Faster Payment Processing",
 consultingAvgPaymentTime: "Average Payment Time",
 consultingCountriesSupported: "Countries Supported",
 consultingPaymentProcessing: "Payment Processing",
 consultingChallengesTitle: "Consulting Payment Challenges",
 consultingChallengesDesc: "Why traditional payments don't work for consulting firms",
 consultingChallenge1Title: "International Consultant Payments",
 consultingChallenge1Desc: "Consulting firms struggle with paying independent consultants and experts across different countries and currencies.",
 consultingChallenge2Title: "Project-Based Payment Cycles",
 consultingChallenge2Desc: "Consultants need timely payments for milestone-based work, but traditional banking creates delays and cash flow issues.",
 consultingChallenge3Title: "High Cross-Border Fees",
 consultingChallenge3Desc: "International wire transfers and currency conversion fees reduce consultant compensation and project profitability.",
 consultingSolutionsTitle: "How Flip Empowers Consulting Firms",
 consultingSolutionsDesc: "Professional payments for expert knowledge workers",
 consultingSolution1Title: "Expert Consultant Payments",
 consultingSolution1Desc: "Pay independent consultants, subject matter experts, and advisors worldwide using just their phone number.",
 consultingSolution1Benefit: "No technical barriers for senior consultants",
 consultingSolution2Title: "Milestone-Based Payments",
 consultingSolution2Desc: "Process project milestone payments instantly with transparent pricing and real-time tracking.",
 consultingSolution2Benefit: "Improve consultant satisfaction and retention",
 consultingSolution3Title: "Enterprise Documentation",
 consultingSolution3Desc: "Built-in documentation features for consulting firms including audit trails and exportable reports.",
 consultingSolution3Benefit: "Meet enterprise governance requirements",
 consultingCtaTitle: "Ready to Streamline Consultant Payments?",
 consultingCtaDesc: "Join consulting firms already using Flip to pay experts worldwide",
 
 // Creative Studios Page - English
 creativeStudiosBuiltFor: "Creative Studios & Agencies",
 creativeStudiosHeroTitle: "Pay Creative Talent",
 creativeStudiosHeroTitleHighlight: "Worldwide",
 creativeStudiosHeroDesc: "Flip makes it simple for creative studios to pay designers, artists, photographers, and other creative professionals globally. No complex crypto wallets – just phone numbers.",
 creativeStudiosStartPaying: "Start Paying Creatives",
 creativeStudiosSeeUseCases: "See Creative Use Cases",
 creativeStudiosCount: "Creative Studios",
 creativeStudiosCostReduction: "Cost Reduction vs Traditional Methods",
 creativeStudiosAvgPaymentTime: "Average Payment Time",
 creativeStudiosCountriesSupported: "Countries Supported",
 creativeStudiosPaymentProcessing: "Payment Processing",
 creativeStudiosChallengesTitle: "Creative Industry Payment Challenges",
 creativeStudiosChallengesDesc: "Why traditional payments don't work for creative studios",
 creativeStudiosChallenge1Title: "Global Talent Network",
 creativeStudiosChallenge1Desc: "Creative studios work with artists, designers, and freelancers worldwide but struggle with international payment complexities.",
 creativeStudiosChallenge2Title: "Project-Based Payments",
 creativeStudiosChallenge2Desc: "Creative work often involves milestone payments and quick turnarounds that traditional banking can't support.",
 creativeStudiosChallenge3Title: "High Payment Costs",
 creativeStudiosChallenge3Desc: "Traditional international transfers eat into creative budgets with high fees and poor exchange rates.",
 creativeStudiosSolutionsTitle: "How Flip Empowers Creative Studios",
 creativeStudiosSolutionsDesc: "Simple payments for complex creative projects",
 creativeStudiosSolution1Title: "Pay Designers Instantly",
 creativeStudiosSolution1Desc: "Send payments to graphic designers, UI/UX experts, and artists worldwide using just their phone number.",
 creativeStudiosSolution1Benefit: "simple phone-number payouts for creative talent",
 creativeStudiosSolution2Title: "Photography & Video Teams",
 creativeStudiosSolution2Desc: "Pay photographers, videographers, and editors across different time zones instantly.",
 creativeStudiosSolution2Benefit: "24/7 payment processing for global projects",
 creativeStudiosSolution3Title: "Music & Audio Production",
 creativeStudiosSolution3Desc: "Compensate musicians, sound engineers, and voice artists immediately after project completion.",
 creativeStudiosSolution3Benefit: "Instant settlements for creative milestones",
 creativeStudiosCtaTitle: "Ready to Streamline Creative Payments?",
 creativeStudiosCtaDesc: "Join creative studios already using Flip to pay talent worldwide",
 
 // E-commerce Page - English
 ecommerceBuiltFor: "E-commerce & Retail",
 ecommerceHeroTitle: "Scale Your E-commerce",
 ecommerceHeroTitleHighlight: "Globally",
 ecommerceHeroDesc: "Flip enables e-commerce businesses to pay suppliers, freelancers, and service providers worldwide instantly. Grow your business without payment boundaries.",
 ecommerceStartPaying: "Start Global Payments",
 ecommerceSeeUseCases: "E-commerce Use Cases",
 ecommerceOrdersProcessed: "Orders Processed",
 ecommerceLowerFees: "Lower Fees vs Bank Transfers",
 ecommerceAvgPaymentTime: "Supplier Payment Time",
 ecommerceBusinessesCount: "E-commerce Businesses",
 ecommerceSuccessRate: "Payment Success Rate",
 ecommerceChallengesTitle: "E-commerce Payment Challenges",
 ecommerceChallengesDesc: "Why traditional payments slow down e-commerce growth",
 ecommerceChallenge1Title: "Global Supplier Network",
 ecommerceChallenge1Desc: "E-commerce businesses work with suppliers, manufacturers, and service providers worldwide but face payment complexities.",
 ecommerceChallenge2Title: "Fast-Moving Inventory",
 ecommerceChallenge2Desc: "Quick inventory restocking and supplier payments are crucial for maintaining competitive advantage.",
 ecommerceChallenge3Title: "Margin Pressure",
 ecommerceChallenge3Desc: "High international payment fees directly impact profit margins in the competitive e-commerce space.",
 ecommerceSolutionsTitle: "How Flip Powers E-commerce Growth",
 ecommerceSolutionsDesc: "Seamless global payments for modern commerce",
 ecommerceSolution1Title: "Pay Suppliers Instantly",
 ecommerceSolution1Desc: "Send payments to manufacturers, dropshippers, and suppliers globally using just their phone number.",
 ecommerceSolution1Benefit: "Faster inventory restocking and better supplier relationships",
 ecommerceSolution2Title: "Freelancer & VA Payments",
 ecommerceSolution2Desc: "Pay virtual assistants, customer service reps, and marketing freelancers across time zones.",
 ecommerceSolution2Benefit: "Scale your team globally without payment barriers",
 ecommerceSolution3Title: "Marketing & Ads Spend",
 ecommerceSolution3Desc: "Compensate affiliate partners, influencers, and marketing agencies worldwide instantly.",
 ecommerceSolution3Benefit: "Expand marketing reach with global talent",
 ecommerceUseCasesTitle: "E-commerce Success Stories",
 ecommerceUseCasesDesc: "How businesses use Flip to scale globally",
 ecommerceUseCase1Title: "Dropshipping Operations",
 ecommerceUseCase1Desc: "Pay suppliers in China, India, and other manufacturing hubs instantly after order confirmation.",
 ecommerceUseCase1Benefit: "Faster fulfillment and better supplier terms",
 ecommerceUseCase2Title: "Amazon FBA Business",
 ecommerceUseCase2Desc: "Compensate product research assistants, PPC managers, and inventory analysts globally.",
 ecommerceUseCase2Benefit: "Scale operations without geographical limits",
 ecommerceUseCase3Title: "Multi-Channel Retail",
 ecommerceUseCase3Desc: "Pay marketplace management teams, customer service, and logistics coordinators worldwide.",
 ecommerceUseCase3Benefit: "24/7 operations across all time zones",
 ecommerceCtaTitle: "Ready to Scale Your E-commerce Business?",
 ecommerceCtaDesc: "Join successful e-commerce businesses using Flip for global payments",
 ecommerceStartPayingGlobally: "Start Paying Globally",
 ecommerceBookConsultation: "Book Consultation",
 
 // Tech Startups Page - English
 techStartupsBuiltFor: "Built for Tech Startups",
 techStartupsHeroTitle: "Scale Your Startup with",
 techStartupsHeroTitleHighlight: "Lightning Payments",
 techStartupsHeroDesc: "Pay your global development team instantly, reduce costs by 60%, and focus on what matters - building the future. Trusted by 500+ startups worldwide.",
 techStartupsStartBuilding: "Start Building",
 techStartupsViewDocs: "View API Docs",
 techStartupsStartupsPowered: "Startups Powered",
 techStartupsDevelopersPaid: "Developers Paid",
 techStartupsAvgCostSavings: "Average Cost Savings",
 techStartupsGlobalSupport: "Global Support",
 techStartupsDeveloperPayments: "Developer Payments",
 techStartupsDeveloperPaymentsDesc: "Pay your remote development team globally with instant settlements",
 techStartupsScaleFast: "Scale Fast",
 techStartupsScaleFastDesc: "Grow your team without payment bottlenecks or banking delays",
 techStartupsGlobalTalent: "Global Talent",
 techStartupsGlobalTalentDesc: "Access the best developers worldwide without payment barriers",
 techStartups247Availability: "24/7 Availability",
 techStartups247Desc: "Payments work around the clock, matching your development cycles",
 techStartupsPerfectForGrowing: "Perfect for Growing Startups",
 techStartupsPerfectForGrowingDesc: "Everything you need to pay your global team and scale without limits",
 techStartupsDeveloperFirstIntegration: "Developer-First Integration",
 techStartupsBuiltByDevelopers: "Built by developers, for developers",
 techStartupsViewDocumentation: "View Documentation",
 techStartupsSuccessStory: "Success Story",
 techStartupsTheChallenge: "The Challenge",
 techStartupsTheSolution: "The Solution",
 techStartupsResults: "Results",
 techStartupsBuiltForSpeed: "Built for Startup Speed",
 techStartupsLovedByFounders: "Loved by Startup Founders",
 techStartupsResourcesForFounders: "Resources for Startup Founders",
 techStartupsReadyToScale: "Ready to Scale Your Startup?",
 techStartupsReadyToScaleDesc: "Join hundreds of startups already using Flip to scale their global teams.",
 techStartupsJoinWaitlist: "Get started free",
 techStartupsTalkToFounder: "Talk to Founder",
 
 // Freelancer Platforms Page - English
 freelancerPlatformsBuiltFor: "#1 Payment Solution for Global Platforms",
 freelancerPlatformsHeroTitle: "Pay Freelancers with",
 freelancerPlatformsHeroTitleHighlight: "Phone Numbers Only",
 freelancerPlatformsHeroDesc: "The first crypto-powered payment platform that lets you pay freelancers instantly using just their phone number. 2.5% flat fee. Payments in minutes. Simple and transparent.",
 freelancerPlatformsStartPaying: "Start Free Integration",
 freelancerPlatformsSeeDemo: "See Live Demo",
 freelancerPlatformsPaymentsProcessed: "Payments Processed",
 freelancerPlatformsHappyFreelancers: "Happy Freelancers",
 freelancerPlatformsFlatFeeRate: "Flat Fee Rate",
 freelancerPlatformsAvgPaymentTime: "Average Payment Time",
 freelancerPlatformsBenefitsTitle: "Why Leading Platforms Choose Flip",
 freelancerPlatformsBenefitsDesc: "Disrupt the expensive, time-consuming and cumbersome traditional payment methods",
 freelancerPlatformsComparisonTitle: "See How Flip Compares",
 freelancerPlatformsComparisonDesc: "Traditional payment methods vs Flip's blockchain innovation",
 freelancerPlatformsCaseStudyTitle: "Success Story",
 freelancerPlatformsFeaturesTitle: "Built for the Global Market",
 freelancerPlatformsFeaturesDesc: "The only payment platform designed specifically for global freelancer platforms",
 freelancerPlatformsTestimonialsTitle: "What Platform Leaders Say",
 freelancerPlatformsCtaTitle: "Ready to Transform Your Freelancer Payments?",
 freelancerPlatformsCtaDesc: "Join the world's leading platforms already using Flip to pay freelancers instantly",
 freelancerPlatformsStartFreeIntegration: "Start Free Integration",
 
 // Navigation
 "nav.home": "Home",
 "nav.uae": "UAE",
 "nav.resources": "Resources",

 // Homepage — Hero
 homeHeroLabel: "Bulk stablecoin payments",
 homeHeroTitle1: "Exchanges Built Trading. We Built Paying",
 homeHeroSubtitle: "Bulk stablecoin payments for businesses. Add contractors by phone number, send batch payments in seconds.",
 homeHeroButton: "Claim Your Free Transfers",
 homeHeroDemoButton: "Book Demo",
 headerLogin: "Log in",
 headerSignup: "Login / Sign Up",
 homeHeroLink: "See how it works",
 homeHeroFootnote: "",

 // Homepage — Differentiator Strip
 diffTitle1: "Bulk payouts in seconds",
 diffDesc1: "Send to your entire team in one transaction. No more 1-by-1 wires or manual chases.",
 diffTitle2: "No platform for your team to join",
 diffDesc2: "Contractors receive USDC to their phone number — instantly.",
 diffTitle3: "USDC-native, MENA-first",
 diffDesc3: "Built for the corridors where USDC is what your team actually wants to receive.",

 // Homepage — Mid-page Demo CTA
 demoCTATitle: "Paying 20+ people, or running payments for a global team?",
 demoCTASub: "Book a 15-minute call. We'll walk through your specific setup, answer your setup questions, and show you how Flip handles batch payouts at scale.",
 demoCTAButton: "Book Demo",

 // Homepage — Trust Block
 trustSignal1: "Operated by Flip Company AS",
 trustSignal2: "Built for global business payouts",

 // Homepage — Problem Section
 problemTitle: "Paying a global contractor team is broken",
 problemSubtitle: "Every method has a catch. Wire transfers bleed fees, EOR platforms lock you in, and crypto wallets push complexity onto your team.",
 problemCard1Title: "Wire transfers",
 problemCard1Item1: "$25–50 per contractor per transfer",
 problemCard1Item2: "3–5 business days delivery",
 problemCard1Item3: "Bank rejections and failed routing",
 problemCard1Item4: "Hidden FX spreads of 1–4%",
 problemCard2Title: "EOR platforms (Deel, Remote)",
 problemCard2Item1: "$300–500/mo per contractor",
 problemCard2Item2: "Weeks of onboarding per person",
 problemCard2Item3: "Locked into annual plans",
 problemCard3Title: "Crypto wallets",
 problemCard3Item1: "Contractors download apps, manage seed phrases",
 problemCard3Item2: "Self off-ramp from USDC",
 problemCard3Item3: "Support burden falls on you",
 problemClosing: "Flip is the lightweight rail for teams that just need to pay people, fast.",

 // Homepage — How It Works
 howItWorksSectionTitle: "Three steps. One transaction.",
 hiwStep1Title: "Add your team",
 hiwStep1Desc: "CSV upload or one-by-one. Just name and phone number — no wallet addresses, no invitation emails.",
 hiwStep2Title: "Set the amounts",
 hiwStep2Desc: "Define per-contractor pay in USD. Save as a template for recurring payments.",
 hiwStep3Title: "Send the batch",
 hiwStep3Desc: "One signature, one transaction, everyone paid in seconds. Track delivery in real time.",
 hiwCardTitle: "How Flip works",
 hiwStepLabel: "Step",
 hiwStatusDelivered: "Delivered",
 hiwStatusPending: "Pending",
 hiwStatusReturned: "Returned",
 hiwFootnote: "From signup to first payment: typically 1-2 business days.",
 hiwCorridors: "Works across multiple payout corridors.",

 // Homepage — Why Flip
 whyFlipSectionTitle: "Why teams choose Flip",
 whyFlip1Title: "No recipient onboarding",
 whyFlip1Desc: "Phone number is enough — send USDC in seconds.",
 whyFlip1Label1: "Recipient",
 whyFlip1Status: "Ready to receive",
 whyFlip2Title: "Settles in seconds",
 whyFlip2Desc: "Skip the 3–5 day banking delay. USDC settles on-chain in seconds.",
 whyFlip2Wire: "Wire transfer",
 whyFlip2FlipSpeed: "Seconds",
 whyFlip3Title: "One transaction, whole team",
 whyFlip3Desc: "Batch your entire payment run into a single transaction.",
 whyFlip3Recipients: "Recipients",
 whyFlip3Total: "Total batch",
 whyFlip3Sent: "All sent",
 whyFlip4Title: "Lower fees",
 whyFlip4Desc: "No per-contractor platform fee. No wire fees. Just a flat percentage.",
 whyFlip4WireFee: "Wire fee (per person)",
 whyFlip4PlatformFee: "EOR platform fee",
 whyFlip4FlipFee: "Flip fee",

 // Homepage — FAQ
 homeFaqTitle: "Frequently asked questions",
 homeFaq1Q: "What is Flip?",
 homeFaq1A: "Flip is a B2B payment platform that lets businesses pay international contractors, freelancers and remote teams in over 100 countries by sending USDC — the recipient receives funds in USDC, typically in under 5 minutes.",
 homeFaq2Q: "Can recipients in any country receive USDC?",
 homeFaq2A: "Yes. Anyone with a phone number can receive USDC from Flip in 100+ countries — no bank account required on their side.",
 homeFaq3Q: "How long do USDC payments take on Flip?",
 homeFaq3A: "Most cross-border payments settle in under 5 minutes, compared with 1–5 business days for traditional SWIFT bank transfers.",
 homeFaq4Q: "Which countries does Flip support?",
 homeFaq4A: "Flip supports payouts to contractors and freelancers in over 100 countries worldwide",
 homeFaq5Q: "What's the pricing?",
 homeFaq5A: "Flip charges a flat percentage per transaction — starting at 2% for standard volume. No setup fees, no monthly minimums, no per-contractor platform fees. Volume discounts available.",
 homeFaq6Q: "How is Flip different from Deel or Remote?",
 homeFaq6A: "Deel and Remote are EOR platforms that charge $300–500/month per contractor and require weeks of onboarding. Flip is a payment rail — add contractors by phone number, pay in seconds, no per-seat fee.",

 // Homepage — Testimonial
 homeTestimonialQuote: "Payouts just work now — fewer follow-ups and fewer returns.",
 homeTestimonialAuthor: "Finance Lead",
 homeTestimonialCompany: "Services business",

 // Homepage — Final CTA
 homeFinalCtaTitle: "Ready to pay your team in seconds?",
 homeFinalCtaFlip: "Flip",
 homeFinalCtaSubtitle: "Free to create an account. No credit card required.",
 homeFinalCtaPlaceholder: "Enter your work email",
 homeFinalCtaButton: "Start paying in USDC",
 homeFinalCtaDemoButton: "Or Book Demo",
 homeFinalCtaDisclaimer: "Free to create an account. No credit card required.",
 homeFinalCtaPlaybook: "Not ready? Get the contractor payments playbook",
 homeFinalCtaTeamSize: "Team size",
 homeFinalCtaSend: "Send",

 // Homepage — Use Cases card content
 realBusinessUseCases: "Built for teams of every size",
 useCasesDescription: "From dev shops to global enterprises, Flip handles bulk USDC payouts at any scale — from 5 contractors to 5,000.",
 useCaseTechTitle: "Dev shops & agencies",
 useCaseTechDesc: "Pay 30 contractors across 12 countries every Friday. CSV upload, one transaction, done.",
 useCaseAgencyTitle: "Content & creator agencies",
 useCaseAgencyDesc: "Pay writers, editors, and designers in LATAM, Eastern Europe, and Southeast Asia.",
 useCaseRemoteTitle: "E-commerce ops",
 useCaseRemoteDesc: "Pay your VA team, freelance designers, and support contractors without wire fees.",
 useCaseEnterpriseTitle: "Enterprise & Global Operations",
 useCaseEnterpriseDesc: "Pay distributed teams across multiple regions with a single payment cycle. Custom approval workflows, dedicated support, and direct integration with your finance stack.",

 // Homepage — Trust Block
 trustGlobalLine: "Trusted by teams in 40+ countries",
 trustCoinmenaContext: "Flip Company AS — global stablecoin payments for business",
 trustNbxContext: "Built for global business payouts",

 // Enterprise page
 enterpriseHeroTitle: "Contractor payments built for enterprise scale",
 enterpriseHeroSub: "Pay distributed teams across multiple regions with a single payment cycle. Custom approval workflows, dedicated support, and direct integration with your finance stack. Built for ops leaders running 100+ contractor programs.",

 // Homepage — Comparison Table
 compTitle: "How Flip Compares",
 compWireHeader: "Wire Transfers",
 compEorHeader: "Deel / EOR",
 compSetupTime: "Setup time",
 compFlipSetup: "Minutes",
 compWireSetup: "Days",
 compEorSetup: "Weeks",
 compRecipientOnboarding: "Recipient onboarding",
 compFlipOnboarding: "None — phone number",
 compWireOnboarding: "Bank details required",
 compEorOnboarding: "Full platform signup",
 compPaymentSpeed: "Payment speed",
 compFlipSpeed: "Seconds",
 compWireSpeed: "3–5 days",
 compEorSpeed: "1–5 days",
 compPerContractorCost: "Per-contractor cost",
 compFlipCost: "2% per tx",
 compWireCost: "$25–50 per tx",
 compEorCost: "$300–500/mo",
 compBatchPayments: "Batch payments",
 compKybFriction: "KYB friction",
 compFlipKyb: "Standard — 1-2 days",
 compWireKyb: "Varies by bank",
 compEorKyb: "Complex — weeks",
 compCurrencyDelivered: "Currency delivered",
 compFlipCurrency: "USDC",
 compWireCurrency: "USDC",
 compEorCurrency: "USDC",
 compBestFor: "Best for",
 compFlipBestFor: "Speed, scale, low cost",
 compWireBestFor: "One-off transfers",
 compEorBestFor: "Full employment",
 },
 ar: {
 // Header
 business: "للشركات",
 personal: "شخصي",
 signup: "اشتراك",
 login: "تسجيل الدخول",
 
 // Navigation
 solutions: "الحلول",
 industries: "الصناعات",
 company: "الشركة",
 joinWaitlist: "سجّل مجاناً",
 
 // Solutions Menu
 paymentSolutions: "حلول الدفع",
 crossBorderPayments: "المدفوعات عبر الحدود",
 freelancerPayments: "مدفوعات المستقلين",
 bulkPayments: "المدفوعات الجماعية",
 apiIntegration: "تكامل API",
 mainPages: "الصفحات الرئيسية",
 allSolutions: "جميع الحلول",
 features: "المميزات",
 pricing: "الأسعار",
 
 // Industries Menu
 serviceIndustries: "الصناعات الخدمية",
 freelancerPlatforms: "منصات المستقلين",
 recruitmentAgencies: "وكالات التوظيف",
 consultingFirms: "شركات الاستشارات",
 techAndCreative: "التكنولوجيا والإبداع",
 techStartups: "الشركات الناشئة التقنية",
 creativeStudios: "الاستوديوهات الإبداعية",
 ecommerce: "التجارة الإلكترونية",
 overview: "نظرة عامة",
 allIndustries: "جميع الصناعات",
 
 // Company Menu
 about: "حول",
 aboutUs: "من نحن",
 whyChooseFlip: "لماذا تختار Flip",
 contactUs: "اتصل بنا",
 resources: "الموارد",
 blog: "المدونة",
 resourceHub: "مركز الموارد",
 
 // Hero Section
 heroTitle: "أرسل مدفوعات USDC عالمياً باستخدام رقم الهاتف فقط",
 heroSubtitle: "وفّر على رسوم الصرف المخفية ورسوم المعاملات",
 getStarted: "ابدأ مجاناً",
 ctaSubtext: "إعداد في 5 دقائق",
 heroHeadline: "ادفع للمستقلين والمقاولين باستخدام USDC",
 
 // Value Proposition Bullets
 fasterPayments: "أرسل مدفوعات USDC عالمياً باستخدام رقم الهاتف فقط",
 saveOnFees: "وفر حتى 85% من رسوم البنوك",
 secureTransparent: "فوري وآمن وبسيط — المستقلون يتلقون المدفوعات مباشرة ولديهم السيطرة الكاملة على أموالهم",
 builtForBusiness: "مصمم للمستقلين والشركات الناشئة والفرق عن بُعد",
 
 // Non-Custodial Messaging
 nonCustodialBadge: "غير احتجازي",
 neverHoldFunds: "نحن لا نحتجز أموال المستقلين أبداً",
 trueOwnership: "ملكية حقيقية - المستقلون يتحكمون بمفاتيحهم",
 zeroCounterpartyRisk: "صفر مخاطر الطرف المقابل",
 selfCustodySecurity: "أمان الحفظ الذاتي",
 fundsFlowDirectly: "الأموال تتدفق مباشرة للمستلمين",
 noSinglePointFailure: "لا نقطة فشل واحدة",
 
 // Key Benefits
 sendToPhone: "مدفوعات عالمية فورية",
 sendToPhoneDesc: "ادفع للمستقلين عالمياً في دقائق، وليس أيام.",
 instantSettlements: "وفر حتى 85% في الرسوم",
 instantSettlementsDesc: "العملات المستقرة تزيل رسوم البنوك.",
 bankGradeSecurity: "أمان غير احتجازي",
 bankGradeSecurityDesc: "المستقلون يملكون مفاتيحهم. نحن لا نحتجز الأموال.",
 fastLowCost: "مدفوعات عبر الحدود 24/7",
 fastLowCostDesc: "مدفوعات فورية لا تنام أبداً.",
 
 // Use Cases Section (legacy keys kept for other pages)

 freelancerPaymentsUseCase: "مدفوعات المستقلين",
 customerRefunds: "استرداد العملاء",
 vendorPayments: "مدفوعات الموردين",
 expenseReimbursements: "تعويض المصروفات",
 learnMore: "اعرف المزيد",
 
 // Trust & Security Section
 completePaymentControl: "السيطرة الكاملة على المدفوعات. صفر مخاطر الأعمال.",
 nonCustodialBusinessDesc: "تقنية غير احتجازية تزيل مخاطر الطرف المقابل وتضمن استمرارية الأعمال",
 whyNonCustodialMatters: "لماذا غير الاحتجازي مهم للأعمال",
 custodialPaymentRisk: "مخاطر الدفع الاحتجازي",
 flipNonCustodialAdvantage: "ميزة Flip غير الاحتجازية",
 completePaymentControlRetained: "السيطرة الكاملة على المدفوعات محفوظة",
 zeroOperationalDisruption: "صفر مخاطر اختلال العمليات",
 guaranteedBusinessContinuity: "استمرارية الأعمال مضمونة",
 enhancedRegulatoryCompliance: "توثيق مبسّط",
 thirdPartiesControlFunds: "أطراف ثالثة تتحكم في أموالك",
 accountFreezesDisrupt: "تجميد الحسابات يعطل العمليات",
 businessContinuityAtRisk: "استمرارية الأعمال في خطر",
 regulatoryComplications: "متاعب التسوية اليدوية",
 
 // Waitlist Form
 joinWaitlistTitle: "أنشئ حسابك",
 waitlistTitle: "ابدأ التوفير على المدفوعات العالمية",
 waitlistSubtitle: "انضم إلى أكثر من 500 شركة تتحول إلى مدفوعات المقاولين بـ USDC",
 waitlistSuccessTitle: "أنت جاهز!",
 waitlistSuccessDescription: "حسابك جاهز. ابدأ بإرسال المدفوعات اليوم.",
 companyInformation: "معلومات الشركة",
 contactNameField: "اسم الشخص المسؤول",
 emailAddress: "عنوان البريد الإلكتروني",
 phoneNumber: "رقم الهاتف",
 businessInformation: "معلومات الأعمال",
 primaryUseCase: "حالة الاستخدام الأساسية",
 expectedMonthlyVolume: "الحجم الشهري المتوقع",
 uaeExchangeAccount: "حساب بورصة العملات الرقمية",
 exchangeAccountQuestion: "هل لديك بالفعل حساب بورصة عملات رقمية مسجل؟",
 interestedServices: "الخدمات التي تهمك",
 additionalInformation: "معلومات إضافية",
 cancel: "إلغاء",
 submitting: "جارٍ الإرسال...",
 
 // Early Access Inline CTA
 earlyAccessTitle: "ابدأ بإرسال مدفوعات المقاولين من الإمارات",
 earlyAccessSubtitle: "وفر في فرق سعر الصرف وقلل وقت العمليات على مدفوعات المقاولين الخارجيين.",
 earlyAccessPositioning: "مدفوعات المقاولين الجماعية مدعومة بتسوية USDC من الخلفية، تسليم العملة المحلية مباشرة إلى حسابات المقاولين البنكية عبر رقم الجوال — بدون عنوان محفظة، المقاولون لا يحتاجون العملات الرقمية.",
 earlyAccessEmailLabel: "البريد الإلكتروني للعمل",
 earlyAccessEmailPlaceholder: "you@company.com",
 earlyAccessCompanyLabel: "اسم الشركة (اختياري)",
 earlyAccessCompanyPlaceholder: "شركتك",
 earlyAccessVolumeLabel: "الحجم الشهري بالدرهم (اختياري)",
 earlyAccessVolumePlaceholder: "اختر النطاق",
 earlyAccessCorridorsLabel: "الممرات الرئيسية (اختياري)",
 earlyAccessPhoneLabel: "واتساب/جوال (اختياري)",
 earlyAccessPhonePlaceholder: "+971...",
 earlyAccessCTAButton: "سجّل مجاناً",
 earlyAccessSubmitting: "جارٍ الإرسال...",
 earlyAccessTrust1: "المقاولون يستلمون العملة المحلية في بنوكهم",
 earlyAccessTrust2: "تسوية USDC من الخلفية",
 earlyAccessTrust3: "بدون عنوان محفظة، بدون عملات رقمية مطلوبة للمقاولين",
 earlyAccessSocialProof: "بعض فرق الإمارات توفر حوالي {amount} درهم سنوياً عند تجميع مدفوعات المقاولين بـ USDC عبر Flip.",
 earlyAccessSuccessTitle: "أنت جاهز!",
 earlyAccessSuccessMessage: "حسابك جاهز. ابدأ بإرسال مدفوعات المقاولين اليوم.",
 earlyAccessSuccess: "تم إنشاء الحساب!",
 earlyAccessSuccessDesc: "أنت جاهز لبدء إرسال المدفوعات.",
 earlyAccessError: "فشل الإرسال",
 earlyAccessErrorDesc: "يرجى المحاولة مرة أخرى أو التواصل معنا مباشرة.",
 earlyAccessInvalidEmail: "بريد إلكتروني غير صالح",
 earlyAccessInvalidEmailDesc: "يرجى إدخال بريد إلكتروني صالح للعمل.",
 earlyAccessAlreadySubmitted: "مسجّل بالفعل",
 earlyAccessAlreadySubmittedDesc: "لديك حساب بالفعل. سجّل دخولك للبدء!",
 earlyAccessEstimatorToggle: "تقدير التوفير المحتمل (30 ثانية)",
 earlyAccessEstVolume: "حجم المدفوعات الشهري بالدرهم",
 earlyAccessEstMethod: "الطريقة الحالية",
 earlyAccessEstMethodPlaceholder: "اختر الطريقة",
 earlyAccessEstPayouts: "المدفوعات شهرياً",
 earlyAccessEstSpreadQuestion: "هل تعرف فرق سعر الصرف؟",
 earlyAccessEstYes: "نعم",
 earlyAccessEstCalculate: "احسب التقدير",
 earlyAccessEstCurrentCost: "التكلفة الشهرية الحالية المقدرة",
 earlyAccessEstMonthlySavings: "التوفير الشهري المحتمل",
 earlyAccessEstAnnualSavings: "الإمكانية السنوية",
 earlyAccessEstMethodology: "كيف حسبنا هذا",
 earlyAccessEstMethodology1: "فرق سعر الصرف بناءً على النطاقات النموذجية لطريقتك",
 earlyAccessEstMethodology2: "رسوم المعاملات المقدرة لكل دفعة",
 earlyAccessEstMethodology3: "وقت العمليات: ~10 دقائق/دفعة بمعدل 150 درهم/ساعة",
 earlyAccessEstMethodology4: "توفير Flip: تحسين الفرق 0.8-2% + تخفيض الرسوم/العمليات",
 earlyAccessEstDisclaimer: "هذه تقديرات فقط. التوفير الفعلي يعتمد على وضعك الخاص.",
 earlyAccessEstCTAPrompt: "هل تريد البدء؟ سجّل مجاناً أعلاه.",
 
 // How It Works
 howItWorks: "كيف يعمل",
 step1Title: "التمويل بالعملة المحلية",
 step1Desc: "عبّئ عبر تحويل بنكي أو بطاقة.",
 step2Title: "معالجة الدفع",
 step2Desc: "نقوم بالتسوية بالعملات المستقرة عبر شركاء موثوقين.",
 step3Title: "مباشرة للمحفظة",
 step3Desc: "يتلقى المستقلون في محفظتهم غير الاحتجازية.",
 
 // Why Choose Flip
 simplicityTitle: "لا حاجة لخبرة تقنية",
 simplicityDesc: "أنت تدفع بالعملة المحلية، هم يستلمون فوراً مع سيطرة كاملة.",
 builtForBusinessTitle: "مصمم للأعمال",
 builtForBusinessDesc: "دعم محلي مع وصول عالمي.",
 empowerRecipientsTitle: "حرية مالية حقيقية",
 empowerRecipientsDesc: "المستقلون يملكون أموالهم بالكامل - بلا وسطاء.",
 costEffectiveTitle: "رسوم شفافة",
 costEffectiveDesc: "وفر حتى 85% مقارنة بالتحويلات البنكية. بلا رسوم مخفية.",
 
 // Trust & Security Section - Updated Branding
 trustSecurityTitle: "ملكية حقيقية. صفر مخاطر.",
 trustSecuritySubtitle: "امنح مستقليك السيطرة الكاملة مع إزالة مخاطر الدفع عن أعمالك",
 trustPoint1: "استمرارية الأعمال مضمونة",
 trustPoint1Desc: "عملياتك لا تعتمد أبداً على توفر خدمتنا - المستقلون يتحكمون دائماً في أموالهم",
 trustPoint2: "لا قيود على المدفوعات",
 trustPoint2Desc: "حرية من قيود البنوك التقليدية ومخاطر تجميد الحسابات",
 trustPoint3: "إزالة كاملة للمخاطر",
 trustPoint3Desc: "صفر مخاطر طرف مقابل يعني أن أعمالك ليست معرضة أبداً لفشل معالجات الدفع",
 
 // Contact Page
 contactPageTitle: "دعنا نناقش",
 contactPageSubtitle: " تحديات دفع المستقلين",
 contactPageDescription: "احجز عرضاً توضيحياً لترى كيف يحول Flip for Business طريقة دفع الشركات للمستقلين الدوليين بالعملات المستقرة غير الاحتجازية باستخدام أرقام الهواتف فقط - بدون معرفة تقنية مطلوبة.",
 bookDemo: "احجز عرضاً توضيحياً",
 companyName: "اسم الشركة",
 companyNamePlaceholder: "شركتك",
 contactName: "اسم الشخص المسؤول",
 contactNamePlaceholder: "اسمك",
 email: "البريد الإلكتروني",
 emailPlaceholder: "email@example.com",
 phone: "الهاتف",
 phonePlaceholder: "+1 XXX XXX XXXX",
 businessType: "نوع العمل",
 businessTypePlaceholder: "اختر نوع عملك",
 monthlyVolume: "حجم مدفوعات المستقلين الشهرية",
 monthlyVolumePlaceholder: "اختر نطاق الحجم",
 message: "أخبرنا عن تحديات دفع المستقلين لديك",
 messagePlaceholder: "شاركنا التحديات الحالية في دفع المستقلين الدوليين، رسوم التحويل، التأخير، أو التعقيد...",
 required: "*",
 bookDemoButton: "احجز العرض",
 scheduling: "جاري الجدولة...",
 
 // Business Types
 freelancerPlatform: "منصة مستقلين",
 recruitment: "وكالة توظيف",
 creativeMarketing: "وكالة إبداعية/تسويقية",
 techStartup: "شركة تقنية ناشئة",
 consulting: "شركة استشارات",
 otherBusiness: "أعمال أخرى",
 
 // Volume Ranges
 volume0to10k: "$0 - $10,000",
 volume10kto50k: "$10,000 - $50,000",
 volume50kto200k: "$50,000 - $200,000",
 volume200kto500k: "$200,000 - $500,000",
 volume500kplus: "$500,000+",
 
 // Contact Info
 getInTouch: "تواصل معنا",
 emailContact: "business@theflip.app",
 emailDesc: "دعم خبير للشركات",
 phoneContact: "+1 XXX XXX XXXX",
 phoneDesc: "ساعات العمل",
 officeLocation: "العمليات العالمية",
 officeCountry: "حول العالم",
 
 // Schedule Demo (legacy - kept for compatibility)
 scheduleDemo: "تقدير التوفير في التكاليف",
 scheduleDemoDesc: "اكتشف كيف تحدث الشركات ثورة في مدفوعات المستقلين بالعملات المستقرة غير الاحتجازية - بدون تعقيد تقني.",
 demoFeature1: "• عرض مباشر لمدة 30 دقيقة",
 demoFeature2: "• شرح تفصيلي للمدفوعات غير الاحتجازية",
 demoFeature3: "• تحليل توفير التكاليف لأعمالك",
 demoFeature4: "• أسئلة وأجوبة مع خبراء المدفوعات",
 scheduleDemoButton: "جدولة العرض",
 
 // Cost Savings Estimate Calculator
 costSavingsEstimate: "تقدير التوفير في التكاليف",
 costEstimateStep1Desc: "أخبرنا عن مدفوعات المقاولين الخارجيين الحالية",
 costEstimateStep2Desc: "أدخل بياناتك لرؤية التقدير المخصص لك",
 costEstimateStep3Desc: "إليك ما يمكنك توفيره",
 monthlyPayoutVolume: "حجم المدفوعات الشهرية للمقاولين الخارجيين",
 primaryCorridor: "ممر الدفع الرئيسي",
 currentPayoutMethod: "طريقة الدفع الحالية",
 continueButton: "متابعة",
 workEmail: "البريد الإلكتروني للعمل",
 roleTitle: "المسمى الوظيفي (اختياري)",
 seeMyEstimate: "عرض التقدير",
 yourPotentialSavings: "نطاق التوفير المحتمل",
 estimatedMonthlyLeakage: "التسرب الشهري المقدر",
 estimatedAnnualLeakage: "التسرب السنوي المقدر",
 potentialSavingsRate: "التكلفة المحتملة التي يمكن تجنبها",
 ofPayoutVolume: "من حجم المدفوعات",
 savingsDisclaimer: "نطاقات تقريبية بناءً على التكلفة الإجمالية النموذجية (الرسوم + فروق أسعار الصرف). تختلف الأرقام الفعلية حسب الممر والمزود وخصومات البنك المستلم.",
 requestUaeAccess: "سجّل مجاناً",
 runAnotherEstimate: "إجراء تقدير آخر",
 atLeast: "على الأقل",
 backButton: "رجوع",
 selectVolume: "اختر نطاق الحجم",
 selectCorridor: "اختر الممر",
 selectMethod: "اختر الطريقة",
 selectRole: "اختر الدور",
 invalidEmail: "يرجى إدخال بريد إلكتروني صالح",
 
 // Volume buckets
 volumeUnder5k: "أقل من 5 آلاف دولار",
 volume5kTo20k: "5 – 20 ألف دولار",
 volume20kTo50k: "20 – 50 ألف دولار",
 volume50kTo100k: "50 – 100 ألف دولار",
 volume100kPlus: "أكثر من 100 ألف دولار",
 
 // Corridors
 corridorIndia: "الهند",
 corridorPakistan: "باكستان",
 corridorPhilippines: "الفلبين",
 corridorUkEurope: "المملكة المتحدة/أوروبا",
 corridorOther: "أخرى",
 
 // Payment Methods
 methodBankWire: "تحويل بنكي/SWIFT",
 methodWise: "Wise",
 methodPayoneer: "Payoneer",
 methodPaypal: "PayPal",
 methodOther: "أخرى",
 
 // Roles
 roleFounder: "مؤسس/رئيس تنفيذي",
 roleFinance: "المالية",
 roleOps: "العمليات",
 roleOther: "أخرى",
 
 // Toast Messages
 missingInformation: "معلومات مفقودة",
 fillRequiredFields: "يرجى ملء اسم الشركة واسم الشخص المسؤول والبريد الإلكتروني.",
 demoRequestSubmitted: "تم إرسال طلب العرض التوضيحي!",
 demoRequestSuccess: "شكراً لاهتمامك! سنتواصل معك قريباً لجدولة العرض التوضيحي.",
 submissionFailed: "فشل الإرسال",
 submissionError: "حدث خطأ في إرسال طلبك. يرجى المحاولة مرة أخرى.",
 pleaseFillForm: "يرجى ملء النموذج أولاً",
 fillFormFirst: "يرجى ملء نموذج طلب العرض التوضيحي أعلاه قبل الجدولة.",
 demoScheduled: "تم جدولة العرض التوضيحي!",
 demoScheduleSuccess: "لقد تلقينا طلبك وسنتصل بك لتأكيد موعد العرض.",
 schedulingFailed: "فشلت الجدولة",
 schedulingError: "حدث خطأ في جدولة العرض التوضيحي. يرجى المحاولة مرة أخرى.",
 
 // Footer
 beFirstToExperience: "مستقبل المدفوعات التجارية غير الاحتجازية",
 joinBusinesses: "انضم إلى أكثر من 1,000 شركة ترسل مدفوعات عالمية بالفعل. إنشاء حساب مجاني.",
 joinWaitlistNow: "سجّل مجاناً",
 businessesWaiting: "1,247 شركة مسجلة",
 
 // Footer Business Solutions
 businessSolutions: "حلول الأعمال",
 sendCryptoPayments: "إرسال مدفوعات غير احتجازية",
 bulkPaymentProcessing: "معالجة المدفوعات المجمعة",
 vendorSettlements: "تسوية الموردين",
 
 // Footer Resources
 apiDocumentation: "وثائق API",
 faqSupport: "الأسئلة الشائعة والدعم",
 complianceGuide: "دليل التوثيق",
 
 // Footer Contact
 businessHours: "الدعم",
 supportAvailable: "دعم متوفر على مدار الساعة",
 
 // Footer Legal
 allRightsReserved: "جميع الحقوق محفوظة.",
 privacyPolicy: "سياسة الخصوصية",
 termsOfService: "شروط الخدمة",
 language: "اللغة:",
 
 // Trust markers
 trusted: "أكثر من مليون تحميل",
 processed: "+3 مليون دولار معالج",
 countries: "180+ دولة",
 zeroIncidents: "صفر حوادث أمنية",
 trustedPlatform: "منصة موثوقة",
 bankGradeSec: "أمان غير احتجازي • صفر مخاطر حفظ • إطلاق الربع الثاني 2026",
 globalOperations: "العمليات العالمية",
 
 // Enhanced FAQ
 nonCustodialFaq1: "هل تحتجزون أموال المستقلين؟",
 nonCustodialFaq1Answer: "لا، إطلاقاً. جميع الأموال تذهب مباشرة إلى محافظ المستقلين غير الاحتجازية. نحن لا نحتجز أو نحفظ أو نصل إلى أموالهم. المستقلون يحتفظون بالسيطرة الكاملة من خلال مفاتيحهم الخاصة.",
 nonCustodialFaq2: "ماذا لو تعطل Flip؟",
 nonCustodialFaq2Answer: "المستقلون دائماً يتحكمون في أموالهم بشكل مستقل. بما أننا نستخدم محافظ غير احتجازية، أموالهم ليست عرضة للخطر إذا تعطلت خدمتنا. هم يملكون مفاتيحهم الخاصة ويمكنهم الوصول لأموالهم في أي وقت.",
 nonCustodialFaq3: "من لديه الوصول للأموال؟",
 nonCustodialFaq3Answer: "فقط المستقل بمفاتيحه الخاصة لديه الوصول. هذه قوة التكنولوجيا غير الاحتجازية - ملكية حقيقية مع صفر مخاطر طرف مقابل.",
 nonCustodialFaq4: "كيف يختلف هذا عن البنوك أو PayPal؟",
 nonCustodialFaq4Answer: "الخدمات التقليدية تحتجز أموالك ويمكنها تجميد الحسابات. مع نهج Flip غير الاحتجازي، المستقلون لديهم ملكية حقيقية - لا أحد يمكنه تجميد أو تقييد أموالهم.",
 
 // FAQ Section
 frequentlyAskedQuestions: "الأسئلة الشائعة",
 faqSubtitle: "كل ما تحتاج لمعرفته حول مدفوعات المستقلين غير الاحتجازية",
 faqDescription: "احصل على إجابات للأسئلة الشائعة حول دفع المستقلين العالميين بالعملات المستقرة غير الاحتجازية",
 stillHaveQuestions: "لا تزال لديك أسئلة حول المدفوعات غير الاحتجازية؟ نحن هنا للمساعدة.",
 contactSupport: "تواصل مع الدعم",
 
 // FAQ Questions and Answers
 faq1Question: "ما هو Flip for Business؟",
 faq1Answer: "Flip for Business يساعد الشركات على دفع أجور المستقلين الدوليين بالعملات المستقرة غير الاحتجازية. أضف مستقليك باستخدام أرقام هواتفهم، حدد المبالغ، ونحن سنتولى الباقي - لوحة تحكم واحدة بسيطة، تحويل بنكي محلي واحد، مستقلون سعداء كثيرون مع سيطرة كاملة على أموالهم.",
 faq5Question: "كيف يختلف Flip عن مجرد الدفع باستخدام بورصة؟",
 faq5Answer: "معظم البورصات تتطلب منك جمع عناوين المحافظ، والتعامل مع اختيار الشبكة، وإدارة الدفعات يدوياً. معاملة واحدة في كل مرة. Flip for Business يؤتمت العملية مع التسليم غير الاحتجازي، ويزيل العديد من المخاطر، ويوفر تجربة سلسة لكل من شركتك ومستقليك.",
 faq6Question: "هل يحتاج المستقلون لمعرفة تقنية؟",
 faq6Answer: "لا! مستقلوك لا يحتاجون للقلق حول إعداد المحفظة أو الشبكات أو العثور على عناوين البلوك تشين الصحيحة. يستخدمون ببساطة رقم هاتفهم ويتلقون الأموال في محفظتهم الآمنة غير الاحتجازية! لا يوجد منحنى تعلم تقني مطلوب، لكنهم يحتفظون بالملكية الكاملة.",
 faq7Question: "كيف تعمل عملية الدفع؟",
 faq7Answer: "إنها بسيطة: 1) أضف المستقلين بإدخال أرقام الهواتف والمبالغ، 2) احصل على إجمالي واحد من Flip لجميع الدفعات، 3) اختر البورصة المفضلة واعمل تحويل بنكي محلي واحد، 4) كل مستقل يتلقى عملات مستقرة في محفظة Flip App غير الاحتجازية فوراً - هم يملكون المفاتيح، وليس نحن.",
 faq8Question: "ما البورصات التي تدعمونها؟",
 faq8Answer: "ندعم البورصات الرئيسية ونوسع شراكاتنا باستمرار لنمنحك خيارات دفع غير احتجازية أكثر.",
 faq9Question: "هل يمكنني دفع عدة مستقلين دفعة واحدة؟",
 faq9Answer: "نعم! المدفوعات المجمعة سهلة مع Flip. ادفع لمستقل واحد أو عديدين، كل بمبالغ فريدة، في بضع نقرات لمحافظهم الفردية غير الاحتجازية. جميع المدفوعات مدمجة في مبلغ واحد لراحتك.",
 faq10Question: "ما فوائد هذا مقارنة بالمدفوعات التقليدية؟",
 faq10Answer: "السرعة، التكلفة، الأمان، والملكية الحقيقية. المدفوعات الدولية التقليدية قد تستغرق 5-7 أيام، وتكلف 3-8% في الرسوم، وتتضمن مخاطر الحفظ. مع نهج Flip غير الاحتجازي، المدفوعات تُسلم في دقائق، الرسوم عادة أقل من 1%، والمستقلون لديهم سيطرة كاملة على أموالهم.",
 faq11Question: "كيف يتلقى المستقلون مدفوعاتهم؟",
 faq11Answer: "يتلقى المستقلون عملاتهم المستقرة مباشرة في محفظة تطبيق Flip البديهية والبسيطة والآمنة غير الاحتجازية. هم يملكون مفاتيحهم الخاصة - وليس نحن. لا عناوين محافظ، لا ارتباك شبكات، أو صداع تسجيل - فقط رقم هاتفهم وسيادة مالية كاملة.",
 
 // Testimonials Section
 trustedWorldwide: "موثوق عالمياً",
 whatCustomersSay: "ماذا يقول عملاؤنا",
 testimonial1Quote: "خفّض Flip تكاليف دفع المستقلين لدينا بنسبة 70%. مصممونا في أوكرانيا والهند يتقاضون رواتبهم في 10 دقائق بدلاً من 5-7 أيام.",
 testimonial1Author: "أحمد ح.",
 testimonial1Position: "المدير المالي",
 testimonial1Company: "Creative Co.",
 testimonial2Quote: "المدفوعات برقم الهاتف عبقرية. لا حاجة لمحافظ العملات الرقمية. إذا كنت تعرف رقم هاتف، يمكنك الدفع لهم فوراً.",
 testimonial2Author: "سارة م.",
 testimonial2Position: "مديرة العمليات",
 testimonial2Company: "TechSolutions LLC",
 testimonial3Quote: "أمان بمستوى البنوك مع سرعة العملات الرقمية. مدفوعات الموردين الدوليين لدينا تتم في نفس اليوم بدلاً من الانتظار أسبوعاً.",
 testimonial3Author: "محمد ك.",
 testimonial3Position: "المدير المالي",
 testimonial3Company: "Global Innovations",
 
 // Footer additional
 cryptoPaymentsSimple: "مدفوعات العملات الرقمية بسيطة كإرسال رسالة نصية. آمنة ومصممة للأعمال.",
 
 // Hero Section - Additional
 // heroHeadline moved to line 795
 
 // About Page
 aboutGlobalPlatform: "منصة عالمية • خبرة محلية",
 aboutHeroTitle: "تحويل المدفوعات العالمية للشركات الحديثة",
 aboutHeroDescription: "نحن رواد أعمال ومستقلون أنفسنا. بعد معاناتنا مع تحويلات بنكية تستغرق أسابيع ورسوم باهظة عند دفع المقاولين في الخارج، علمنا أنه يجب أن يكون هناك طريقة أفضل.",
 aboutStoryTitle: "قصتنا: من مشكلة إلى حل",
 aboutStoryP1: "تأسست في 2024 بمهمة تبسيط المدفوعات العالمية، ظهرت Flip من تجربة بسيطة لكن محبطة: دفع المستقلين العالميين لا ينبغي أن يستغرق 5-14 يوماً ويكلف 8% في الرسوم.",
 aboutStoryP2: "فريقنا المؤسس يجمع خبرة من البنوك التقليدية وابتكار العملات الرقمية، بتوجيه من مستشارين من صناعة المدفوعات. انطلقنا لسد هذه الفجوة بالعملات المستقرة المدعومة بالدولار.",
 aboutStoryP3: "اليوم، نفخر بخدمة أكثر من 50 شركة حول العالم، معالجة أكثر من 3 ملايين دولار في المدفوعات العالمية بصفر حوادث أمنية.",
 aboutQuote: "خفّض Flip تكاليف دفع المستقلين لدينا بنسبة 70% ومطورونا يتقاضون رواتبهم في اليوم التالي بدلاً من الأسبوع التالي. لقد غيّر طريقة عملنا مع المواهب العالمية.",
 aboutQuoteAuthor: "— أليكس تشين، المدير التقني، TechNova Studios",
 aboutValuesTitle: "القيم التي تقود كل ما نفعله",
 aboutValuesSubtitle: "السرعة، التوفير، البساطة، والأمان – ليست مجرد ميزات، بل مبادئ أساسية",
 aboutMissionTitle: "مهمتنا",
 aboutMissionDesc: "تمكين الشركات حول العالم للانطلاق عالمياً من خلال إزالة العوائق المالية في المدفوعات عبر الحدود عبر تقنية العملات المستقرة.",
 aboutGlobalTitle: "نهج عالمي أولاً",
 aboutGlobalDesc: "مبني بفهم عميق لاحتياجات الأعمال العالمية، نخدم أكثر من 180 دولة مع امتثال تنظيمي كامل.",
 aboutSecurityTitle: "تميز أمني",
 aboutSecurityDesc: "صفر حوادث أمنية حتى الآن. تشفير بمستوى البنوك، محافظ متعددة التوقيع، وشراكات مع مزودي العملات المستقرة المنظمين.",
 aboutCustomerTitle: "نجاح العملاء",
 aboutCustomerDesc: "كل ميزة مصممة مع نجاح الأعمال في الاعتبار. دعم 24/7 وتسعير شفاف وعادل بدون رسوم مخفية.",
 aboutTrustTitle: "الثقة والأمان والامتثال",
 aboutTrustSubtitle: "نعامل مدفوعاتك كما لو كانت مدفوعاتنا – بموثوقية وشفافية وعناية",
 aboutFullyLicensed: "مرخص بالكامل",
 aboutFullyLicensedDesc: "مزود خدمات مالية مرخص مع سياسات KYC/AML صارمة",
 aboutZeroIncidents: "صفر حوادث",
 aboutZeroIncidentsDesc: "تشفير بمستوى البنوك وتدقيق العقود الذكية يضمن سجل أمان مثالي",
 aboutGlobalSupport: "دعم عالمي",
 aboutGlobalSupportDesc: "دعم 24/7 بلغات متعددة – نحن دائماً هنا للمساعدة!",
 aboutCtaTitle: "مستعد للانضمام إلينا في تحويل المدفوعات؟",
 aboutCtaDesc: "Flip في مهمة لإزالة الحدود في المالية. انضم إلينا، ولنبني عالماً حيث يمكن للموهوبين العمل مع أي شخص، في أي مكان – دون أن تبطئهم المدفوعات أبداً.",
 aboutStartTrial: "ابدأ تجربتك المجانية",
 aboutContactTeam: "تواصل مع فريقنا",
 aboutHelpText: "نحن هنا لمساعدتك في البدء بالمدفوعات العالمية",
 aboutFounded: "تأسست",
 aboutLicensedFintech: "تقنية مالية مرخصة",
 aboutProcessedGlobally: "معالج عالمياً",
 aboutAcrossCountries: "عبر 180+ دولة",
 aboutBusinesses: "الشركات",
 aboutTrustFlip: "تثق في Flip يومياً",
 aboutAverageDelivery: "متوسط التوصيل",
 aboutVsTraditional: "مقارنة بـ 5 أيام التقليدية",
 
 // Pricing Page
 pricingTitle: "تسعير بسيط وشفاف",
 pricingSubtitle: "بدون رسوم مخفية، بدون تكاليف إعداد. ادفع فقط للمعاملات الناجحة بأسعار تنافسية تتناسب مع نمو أعمالك.",
 pricingStarter: "المبتدئ",
 pricingStarterPrice: "2.5%",
 pricingStarterDesc: "مثالي للشركات الصغيرة ومنصات المستقلين",
 pricingProfessional: "الاحترافي",
 pricingProfessionalPrice: "1.8%",
 pricingProfessionalDesc: "للشركات النامية ذات أحجام الدفع الأعلى",
 pricingEnterprise: "المؤسسات",
 pricingEnterprisePrice: "مخصص",
 pricingEnterpriseDesc: "حلول مخصصة للمؤسسات الكبيرة",
 pricingPerTransaction: "لكل معاملة",
 pricingMostPopular: "الأكثر شعبية",
 pricingUpTo50k: "حتى 50,000$ حجم شهري",
 pricingPhonePayments: "مدفوعات برقم الهاتف",
 pricingRealTimeTracking: "تتبع فوري",
 pricingEmailSupport: "دعم بالبريد الإلكتروني",
 pricingStandardSettlement: "تسوية قياسية (2-4 ساعات)",
 pricingUpTo500k: "حتى 500,000$ حجم شهري",
 pricingAllStarterFeatures: "جميع ميزات المبتدئ",
 pricingPrioritySupport: "دعم أولوية",
 pricingFastSettlement: "تسوية سريعة (30 دقيقة)",
 pricingDedicatedManager: "مدير حساب مخصص",
 pricingCustomIntegration: "دعم تكامل مخصص",
 pricingUnlimitedVolume: "حجم شهري غير محدود",
 pricingAllProfessionalFeatures: "جميع ميزات الاحترافي",
 pricingWhiteLabel: "خيارات العلامة البيضاء",
 pricingSlaGuarantees: "ضمانات SLA",
 pricing247Support: "دعم هاتفي 24/7",
 pricingCustomCompliance: "ميزات امتثال مخصصة",
 pricingCtaTitle: "ابدأ التوفير في مدفوعات المستقلين اليوم",
 pricingCtaDesc: "بدون رسوم إعداد، بدون حد أدنى شهري. ابدأ بتجربتنا المجانية.",
 pricingContactSales: "تحدث مع المبيعات",
 
 // Features Page
 featuresTitle: "كل ما تحتاجه لدفع المستقلين عالمياً",
 featuresSubtitle: "تقنية شاملة غير احتجازية تدعم المدفوعات الجماعية بالعملات المستقرة، مما يسهل على الشركات دفع المستقلين حول العالم عبر رقم الهاتف.",
 featuresSendToPhone: "الإرسال لأرقام الهواتف",
 featuresSendToPhoneDesc: "بدون عناوين محافظ، بدون معرفة تقنية مطلوبة. فقط رقم هاتف.",
 featuresNoTechnicalBarriers: "لا عوائق تقنية",
 featuresInstantOnboarding: "تسجيل فوري للمستلمين",
 featuresWorksWithAnyMobile: "يعمل مع أي رقم جوال",
 featuresLocalCurrency: "مدفوعات بالعملة المحلية",
 featuresLocalCurrencyDesc: "يتلقى المستلمون الأموال عبر شركاء محليين منظمين بعملتهم المفضلة.",
 featuresSeamlessDelivery: "توصيل سلس بالعملة المحلية",
 featuresCompetitiveRates: "أسعار تنافسية",
 featuresDirectBankDeposits: "إيداعات بنكية مباشرة",
 featuresRealTimeTracking: "تتبع فوري",
 featuresRealTimeTrackingDesc: "راقب كل معاملة من البداية حتى التسليم النهائي.",
 featuresLiveUpdates: "تحديثات حية للحالة",
 featuresDeliveryConfirmations: "تأكيدات التسليم",
 featuresTransactionHistory: "سجل المعاملات",
 featuresLowFees: "رسوم منخفضة",
 featuresLowFeesDesc: "تسعير شفاف بتكاليف أقل بكثير من الطرق التقليدية.",
 featuresNoHiddenCharges: "بدون رسوم مخفية",
 featuresVolumeDiscounts: "خصومات على الحجم",
 featuresFlatFeeStructure: "هيكل رسوم ثابت",
 featuresInstantSettlements: "تسويات فورية",
 featuresInstantSettlementsDesc: "المدفوعات تُعالج وتُسلم في دقائق، وليس أيام.",
 features247Processing: "معالجة 24/7",
 featuresNoBankingHours: "لا ساعات عمل بنكية",
 featuresWeekendAvailability: "متاح في عطلات نهاية الأسبوع",
 featuresCtaTitle: "مستعد لإحداث ثورة في مدفوعات المستقلين؟",
 featuresCtaDesc: "انضم للشركات التي تستخدم بالفعل حلول الدفع غير الاحتجازية الجاهزة للمؤسسات",
 featuresGetEarlyAccess: "احصل على وصول مبكر",
 featuresBookDemo: "احجز عرضاً توضيحياً",
 
 // Solutions Page
 solutionsLeadingPlatform: "منصة العملات المستقرة الرائدة",
 solutionsHeroTitle: "حلول الدفع العالمية الشاملة",
 solutionsHeroDesc: "مدفوعات جماعية بالعملات المستقرة عبر رقم الهاتف. مصممة للمستقلين والشركات الناشئة والفرق عن بُعد.",
 solutionsProvenResults: "نتائج مثبتة",
 solutionsFreelancerEconomy: "اقتصاد المستقلين",
 solutionsAnnualMarket: "السوق السنوي",
 solutionsDownloads: "التحميلات",
 solutionsProvenPlatform: "منصة مثبتة",
 solutionsProcessed: "معالج",
 solutionsTrustedVolume: "حجم موثوق",
 solutionsCostSavings: "توفير التكاليف",
 solutionsVsBanks: "مقارنة بالبنوك",
 solutionsSpeedSavings: "السرعة. التوفير. البساطة. الأمان.",
 solutionsGlobalPayouts: "المدفوعات العالمية المبسطة",
 solutionsGlobalPayoutsDesc: "لوحة تحكم واحدة لجميع المدفوعات العالمية. موّل محلياً، وصّل عالمياً في دقائق.",
 solutionsLocalCurrency: "مدفوعات بالعملة المحلية",
 solutionsLocalCurrencyDesc: "عملة مستقرة بالدولار أو عملة محلية. أسعار السوق الحقيقية عبر شركاء محليين منظمين.",
 solutionsCompleteReporting: "تقارير شاملة",
 solutionsCompleteReportingDesc: "تقارير قابلة للتحميل، سجلات تدقيق، وإيصالات آلية للمحاسبة.",
 solutionsSecuritySupport: "الأمان والدعم",
 solutionsSecuritySupportDesc: "تشفير بمستوى البنوك، محافظ متعددة التوقيع. فريق دعم 24/7.",
 solutionsEveryBusiness: "حلول لكل احتياجات الأعمال",
 solutionsFreelancerPayments: "مدفوعات المستقلين",
 solutionsFreelancerPaymentsDesc: "ادفع للمواهب عن بُعد حول العالم فوراً. مصمم لاقتصاد المستقلين العالمي.",
 solutionsFreelancerFeature1: "رسوم 2.5% مقابل 10-20% للمنصات",
 solutionsFreelancerFeature2: "تسوية في دقائق مقابل أيام",
 solutionsFreelancerFeature3: "مدفوعات برقم الهاتف",
 solutionsFreelancerFeature4: "تسليم غير احتجازي",
 solutionsMostPopular: "الأكثر شعبية",
 solutionsCrossBorder: "المدفوعات عبر الحدود",
 solutionsCrossBorderDesc: "أرسل مدفوعات الأعمال عالمياً في دقائق. مثالي للموردين والشركاء.",
 solutionsCrossBorderFeature1: "أرخص 90% من التحويلات البنكية",
 solutionsCrossBorderFeature2: "تحويلات عالمية فورية",
 solutionsCrossBorderFeature3: "سجلات تدقيق كاملة",
 solutionsCrossBorderFeature4: "تتبع فوري",
 solutionsBulkPayments: "المدفوعات المجمعة",
 solutionsBulkPaymentsDesc: "معالجة مئات المدفوعات في وقت واحد. مثالي للرواتب والعمولات.",
 solutionsBulkFeature1: "رفع CSV لآلاف المدفوعات",
 solutionsBulkFeature2: "معالجة مجمعة فورية",
 solutionsBulkFeature3: "تحقق آلي",
 solutionsBulkFeature4: "تقارير مفصلة",
 solutionsLearnMore: "اعرف المزيد والأسعار",
 solutionsFlipAdvantage: "ميزة Flip",
 solutionsSeeAdvantage: "شاهد ميزة Flip",
 solutionsSeeForYourself: "شاهد الفرق بنفسك",
 solutionsMethod: "الطريقة",
 solutionsTime: "الوقت",
 solutionsFees: "الرسوم",
 solutionsSetup: "الإعداد",
 solutionsMinutes: "دقائق",
 solutionsPhoneNumber: "رقم الهاتف",
 solutionsBankTransfer: "التحويل البنكي",
 solutions1to5Days: "1-5 أيام",
 solutionsComplexSetup: "إعداد معقد",
 solutionsAccountVerification: "تحقق من الحساب",
 solutionsFreelancerPlatforms: "منصات المستقلين",
 solutions3to7Days: "3-7 أيام",
 solutionsPlatformDependency: "اعتماد على المنصة",
 solutionsReadyToTransform: "مستعد لتحويل مدفوعاتك؟",
 solutionsReadyToTransformDesc: "انضم للشركات التي تستخدم بالفعل حلول العملات المستقرة غير الاحتجازية.",
 solutionsRequestCaseStudies: "اطلب دراسات الحالة",
 solutionsNoSetupFees: "✓ بدون رسوم إعداد ✓ إلغاء في أي وقت ✓ دعم 24/7 ✓ آمن وموثوق",
 
 // WhyFlip Page
 whyFlipTitle: "لماذا تختار Flip؟",
 whyFlipDesc: "طرق الدفع التقليدية بطيئة ومكلفة ومعقدة. Flip يغير كل شيء ببساطة مدعومة بالعملات الرقمية.",
 whyFlipVsTraditional: "Flip مقابل الطرق التقليدية",
 whyFlipSeeForYourself: "شاهد الفرق بنفسك",
 whyFlipFeature: "الميزة",
 whyFlipTraditionalBanks: "البنوك التقليدية",
 whyFlipSetupTime: "وقت الإعداد",
 whyFlip2to4Weeks: "2-4 أسابيع",
 whyFlip5Minutes: "5 دقائق",
 whyFlipInternationalFees: "الرسوم الدولية",
 whyFlip3to7Percent: "3-7% + رسوم ثابتة",
 whyFlipLessThan25: "< 2.5% رسوم",
 whyFlipSettlementTime: "وقت التسوية",
 whyFlip3to5Days: "3-5 أيام عمل",
 whyFlipInstant: "فوري",
 whyFlipWeekendProcessing: "المعالجة في العطلات",
 whyFlipNo: "لا",
 whyFlip247: "متاح 24/7",
 whyFlipCompliance: "الامتثال",
 whyFlipComplexDocs: "وثائق معقدة",
 whyFlipUaeRegulated: "منظم ومتوافق مع الإمارات",
 whyFlipAdvantage: "ميزة Flip",
 whyFlipEverythingYouNeed: "كل ما تحتاجه، ولا شيء لا تحتاجه",
 whyFlipBenefit1: "وفر 70% على رسوم المدفوعات الدولية",
 whyFlipBenefit2: "تسويات فورية مقابل تأخير 3-5 أيام",
 whyFlipBenefit3: "معالجة 24/7 بما في ذلك العطلات",
 whyFlipBenefit4: "بدون رسوم مخفية أو مفاجآت",
 whyFlipBenefit5: "امتثال تنظيمي إماراتي مدمج",
 whyFlipBenefit6: "مدفوعات برقم الهاتف",
 whyFlipTrustedByBusinesses: "موثوق من الشركات النامية",
 whyFlipCustomerSatisfaction: "رضا العملاء",
 whyFlipProcessedMonthly: "معالج شهرياً",
 whyFlipActiveBusinesses: "الشركات النشطة",
 whyFlipTestimonial: "لقد غيّر Flip طريقة دفع فريقنا الدولي. ما كان يستغرق أسبوعاً يحدث الآن في دقائق، وقد خفضنا تكاليف الدفع بنسبة 60%.",
 whyFlipTestimonialAuthor: "سارة أحمد",
 whyFlipTestimonialPosition: "الرئيس التنفيذي، TechStartup Dubai",
 
 // FAQ Page Additional
 faqTeamHere: "فريقنا هنا لمساعدتك في أي أسئلة حول Flip for Business.",
 
 // Industry Pages - Common
 industryBuiltFor: "مصمم لـ",
 industryGetStarted: "ابدأ الآن",
 industryScheduleDemo: "جدولة عرض توضيحي",
 industryLearnMore: "اعرف المزيد",
 industryChallenges: "التحديات",
 industrySolutions: "الحلول",
 industryHowWeHelp: "كيف نساعد",
 industryReadyToStart: "مستعد للبدء؟",
 
 // Tech Startups Page
 techStartupsBuiltFor: "مصمم للشركات التقنية الناشئة",
 techStartupsHeroTitle: "نمِّ شركتك الناشئة مع مدفوعات سريعة كالبرق",
 techStartupsHeroDesc: "ادفع لفريق التطوير العالمي فوراً، وفر 60% من التكاليف، وركز على ما يهم - بناء المستقبل. موثوق من 500+ شركة ناشئة حول العالم.",
 techStartupsStartBuilding: "ابدأ البناء",
 techStartupsViewDocs: "عرض وثائق API",
 techStartupsStartupsPowered: "شركات ناشئة مدعومة",
 techStartupsDevelopersPaid: "مطورون تم دفعهم",
 techStartupsAvgCostSavings: "متوسط توفير التكاليف",
 techStartupsGlobalSupport: "دعم عالمي",
 techStartupsDeveloperPayments: "مدفوعات المطورين",
 techStartupsDeveloperPaymentsDesc: "ادفع لفريق التطوير عن بُعد عالمياً مع تسويات فورية",
 techStartupsAvgPayout: "متوسط 10 دقائق للدفع",
 techStartupsScaleFast: "نمو سريع",
 techStartupsScaleFastDesc: "نمِّ فريقك بدون عوائق الدفع أو تأخيرات البنوك",
 techStartupsZeroSetup: "صفر وقت إعداد",
 techStartupsGlobalTalent: "المواهب العالمية",
 techStartupsGlobalTalentDesc: "الوصول لأفضل المطورين حول العالم بدون عوائق الدفع",
 techStartups150Countries: "150+ دولة",
 techStartups247Availability: "متاح 24/7",
 techStartups247Desc: "المدفوعات تعمل على مدار الساعة، لتتوافق مع دورات التطوير",
 techStartups999Uptime: "99.9% وقت التشغيل",
 techStartupsPerfectForGrowing: "مثالي للشركات الناشئة النامية",
 techStartupsPerfectForGrowingDesc: "كل ما تحتاجه لدفع فريقك العالمي والنمو بلا حدود",
 techStartupsDeveloperFirstIntegration: "تكامل للمطورين أولاً",
 techStartupsBuiltByDevelopers: "مبني من مطورين، للمطورين",
 techStartupsRestApi: "REST API",
 techStartupsSimpleEndpoints: "نقاط نهاية بسيطة وموثقة جيداً",
 techStartupsWebhooks: "Webhooks",
 techStartupsRealTimeNotifications: "إشعارات دفع فورية",
 techStartupsSdks: "SDKs",
 techStartupsJsPythonGo: "مكتبات JavaScript، Python، Go",
 techStartupsDashboard: "لوحة التحكم",
 techStartupsRealTimeAnalytics: "تحليلات وتحكمات فورية",
 techStartupsViewDocumentation: "عرض الوثائق",
 techStartupsSuccessStory: "قصة نجاح",
 techStartupsHowScaled: "كيف نمت {company} إلى 50+ مطور",
 techStartupsTheChallenge: "التحدي",
 techStartupsTheSolution: "الحل",
 techStartupsResults: "النتائج",
 techStartupsBuiltForSpeed: "مصمم لسرعة الشركات الناشئة",
 techStartupsInstantPayments: "مدفوعات فورية",
 techStartupsInstantPaymentsDesc: "ادفع لفريق التطوير بالكامل في أقل من 10 دقائق",
 techStartupsVcReadyCompliance: "امتثال جاهز للمستثمرين",
 techStartupsVcReadyComplianceDesc: "امتثال تنظيمي كامل للعناية الواجبة للمستثمرين",
 techStartupsDeveloperFirstApi: "API للمطورين أولاً",
 techStartupsDeveloperFirstApiDesc: "مبني من مطورين، للمطورين - تكامل بسيط",
 techStartupsTrueGlobalReach: "وصول عالمي حقيقي",
 techStartupsTrueGlobalReachDesc: "ادفع لأي شخص، في أي مكان، بدون قيود البنوك التقليدية",
 techStartupsLovedByFounders: "محبوب من مؤسسي الشركات الناشئة",
 techStartupsResourcesForFounders: "موارد لمؤسسي الشركات الناشئة",
 techStartupsReadyToScale: "مستعد لتوسيع نطاق شركتك الناشئة؟",
 techStartupsReadyToScaleDesc: "انضم لمئات الشركات الناشئة التي تستخدم بالفعل Flip لتوسيع فرقها العالمية.",
 
 // Consulting Page
 consultingBuiltFor: "شركات الاستشارات",
 consultingHeroTitle: "ادفع للمستشارين الخبراء عالمياً",
 consultingHeroDesc: "Flip يسهل على شركات الاستشارات دفع المستشارين المستقلين وخبراء الموضوع والمستشارين حول العالم. مدفوعات احترافية بدون التعقيد.",
 consultingStartPayingConsultants: "ابدأ دفع المستشارين",
 consultingSeeUseCases: "شاهد حالات استخدام الاستشارات",
 consultingFirmsCount: "شركات الاستشارات",
 consultingFasterPayment: "معالجة دفع أسرع",
 consultingAvgPaymentTime: "متوسط وقت الدفع",
 consultingCountriesSupported: "الدول المدعومة",
 consultingPaymentProcessing: "معالجة الدفع",
 consultingChallengesTitle: "تحديات دفع الاستشارات",
 consultingChallengesDesc: "لماذا لا تعمل المدفوعات التقليدية لشركات الاستشارات",
 consultingChallenge1Title: "مدفوعات المستشارين الدوليين",
 consultingChallenge1Desc: "تكافح شركات الاستشارات مع دفع المستشارين المستقلين والخبراء عبر دول وعملات مختلفة.",
 consultingChallenge2Title: "دورات الدفع القائمة على المشاريع",
 consultingChallenge2Desc: "يحتاج المستشارون إلى مدفوعات في الوقت المناسب للعمل القائم على المراحل، لكن البنوك التقليدية تخلق تأخيرات ومشاكل في التدفق النقدي.",
 consultingChallenge3Title: "رسوم عالية عبر الحدود",
 consultingChallenge3Desc: "التحويلات البنكية الدولية ورسوم تحويل العملات تقلل من تعويضات المستشارين وربحية المشاريع.",
 consultingSolutionsTitle: "كيف يمكّن Flip شركات الاستشارات",
 consultingSolutionsDesc: "مدفوعات احترافية للعاملين في مجال المعرفة الخبراء",
 consultingSolution1Title: "مدفوعات المستشارين الخبراء",
 consultingSolution1Desc: "ادفع للمستشارين المستقلين وخبراء الموضوع والمستشارين حول العالم باستخدام رقم هاتفهم فقط.",
 consultingSolution1Benefit: "لا عوائق تقنية للمستشارين الكبار",
 consultingSolution2Title: "مدفوعات قائمة على المراحل",
 consultingSolution2Desc: "معالجة مدفوعات مراحل المشروع فوراً مع تسعير شفاف وتتبع فوري.",
 consultingSolution2Benefit: "تحسين رضا المستشارين والاحتفاظ بهم",
 consultingSolution3Title: "توثيق المؤسسات",
 consultingSolution3Desc: "ميزات توثيق مدمجة لشركات الاستشارات تشمل سجلات التدقيق والتقارير القابلة للتصدير.",
 consultingSolution3Benefit: "تلبية متطلبات حوكمة المؤسسات",
 consultingCtaTitle: "مستعد لتبسيط مدفوعات المستشارين؟",
 consultingCtaDesc: "انضم لشركات الاستشارات التي تستخدم بالفعل Flip لدفع الخبراء حول العالم",
 consultingGetStartedToday: "ابدأ اليوم",
 
 // Creative Studios Page
 creativeStudiosBuiltFor: "الاستوديوهات الإبداعية",
 creativeStudiosHeroTitle: "ادفع للمبدعين العالميين فوراً",
 creativeStudiosHeroDesc: "Flip يمكّن الاستوديوهات الإبداعية من دفع المصممين والفنانين والمواهب الإبداعية حول العالم. الدفع السريع يعني عمل إبداعي أفضل.",
 creativeStudiosStartPaying: "ابدأ دفع المبدعين",
 creativeStudiosSeeUseCases: "شاهد حالات الاستخدام الإبداعية",
 creativeStudiosCount: "الاستوديوهات الإبداعية",
 creativeStudiosFasterPayment: "معالجة دفع أسرع",
 creativeStudiosAvgPaymentTime: "متوسط وقت الدفع",
 creativeStudiosCountriesSupported: "الدول المدعومة",
 creativeStudiosPaymentProcessing: "معالجة الدفع",
 creativeStudiosChallengesTitle: "تحديات الدفع للاستوديوهات الإبداعية",
 creativeStudiosChallengesDesc: "لماذا لا تعمل المدفوعات التقليدية للاستوديوهات الإبداعية",
 creativeStudiosChallenge1Title: "مدفوعات المواهب الدولية",
 creativeStudiosChallenge1Desc: "تكافح الاستوديوهات الإبداعية مع دفع المصممين والفنانين والمواهب الإبداعية عبر دول وعملات مختلفة.",
 creativeStudiosChallenge2Title: "دورات الدفع القائمة على المشاريع",
 creativeStudiosChallenge2Desc: "يحتاج المبدعون إلى مدفوعات في الوقت المناسب للعمل القائم على المراحل، لكن البنوك التقليدية تخلق تأخيرات ومشاكل في التدفق النقدي.",
 creativeStudiosChallenge3Title: "رسوم عالية عبر الحدود",
 creativeStudiosChallenge3Desc: "التحويلات البنكية الدولية ورسوم تحويل العملات تقلل من تعويضات المبدعين وربحية المشاريع.",
 creativeStudiosSolutionsTitle: "كيف يمكّن Flip الاستوديوهات الإبداعية",
 creativeStudiosSolutionsDesc: "مدفوعات احترافية للمواهب الإبداعية",
 creativeStudiosSolution1Title: "مدفوعات المواهب الإبداعية",
 creativeStudiosSolution1Desc: "ادفع للمصممين والفنانين والمواهب الإبداعية حول العالم باستخدام رقم هاتفهم فقط.",
 creativeStudiosSolution1Benefit: "لا عوائق تقنية للمبدعين",
 creativeStudiosSolution2Title: "مدفوعات قائمة على المراحل",
 creativeStudiosSolution2Desc: "معالجة مدفوعات مراحل المشروع فوراً مع تسعير شفاف وتتبع فوري.",
 creativeStudiosSolution2Benefit: "تحسين رضا المبدعين والاحتفاظ بهم",
 creativeStudiosSolution3Title: "امتثال المؤسسات",
 creativeStudiosSolution3Desc: "ميزات امتثال مدمجة للاستوديوهات الإبداعية بما في ذلك الوثائق المناسبة وسجلات التدقيق.",
 creativeStudiosSolution3Benefit: "تلبية متطلبات حوكمة المؤسسات",
 creativeStudiosCtaTitle: "مستعد لتبسيط مدفوعات المبدعين؟",
 creativeStudiosCtaDesc: "انضم للاستوديوهات الإبداعية التي تستخدم بالفعل Flip لدفع المواهب حول العالم",
 creativeStudiosGetStartedToday: "ابدأ اليوم",
 
 // Recruitment Agencies Page
 recruitmentBuiltFor: "وكالات التوظيف",
 recruitmentHeroTitle: "ادفع للمقاولين والمرشحين عالمياً",
 recruitmentHeroDesc: "Flip يسهل على وكالات التوظيف دفع المقاولين والمرشحين والمستشارين حول العالم. مدفوعات احترافية بدون التعقيد.",
 recruitmentStartPaying: "ابدأ دفع المقاولين",
 recruitmentSeeUseCases: "شاهد حالات استخدام التوظيف",
 recruitmentAgenciesCount: "وكالات التوظيف",
 recruitmentFasterPayment: "معالجة دفع أسرع",
 recruitmentAvgPaymentTime: "متوسط وقت الدفع",
 recruitmentCountriesSupported: "الدول المدعومة",
 recruitmentPaymentProcessing: "معالجة الدفع",
 recruitmentChallengesTitle: "تحديات دفع التوظيف",
 recruitmentChallengesDesc: "لماذا لا تعمل المدفوعات التقليدية لوكالات التوظيف",
 recruitmentChallenge1Title: "مدفوعات المقاولين الدوليين",
 recruitmentChallenge1Desc: "تكافح وكالات التوظيف مع دفع المقاولين والمرشحين عبر دول وعملات مختلفة.",
 recruitmentChallenge2Title: "دورات الدفع القائمة على المشاريع",
 recruitmentChallenge2Desc: "يحتاج المقاولون إلى مدفوعات في الوقت المناسب للعمل، لكن البنوك التقليدية تخلق تأخيرات ومشاكل في التدفق النقدي.",
 recruitmentChallenge3Title: "رسوم عالية عبر الحدود",
 recruitmentChallenge3Desc: "التحويلات البنكية الدولية ورسوم تحويل العملات تقلل من تعويضات المقاولين وربحية المشاريع.",
 recruitmentSolutionsTitle: "كيف يمكّن Flip وكالات التوظيف",
 recruitmentSolutionsDesc: "مدفوعات احترافية للمقاولين والمرشحين",
 recruitmentSolution1Title: "مدفوعات المقاولين",
 recruitmentSolution1Desc: "ادفع للمقاولين والمرشحين والمستشارين حول العالم باستخدام رقم هاتفهم فقط.",
 recruitmentSolution1Benefit: "لا عوائق تقنية للمقاولين",
 recruitmentSolution2Title: "مدفوعات قائمة على المشاريع",
 recruitmentSolution2Desc: "معالجة مدفوعات المشاريع فوراً مع تسعير شفاف وتتبع فوري.",
 recruitmentSolution2Benefit: "تحسين رضا المقاولين والاحتفاظ بهم",
 recruitmentSolution3Title: "جاهز للتوثيق",
 recruitmentSolution3Desc: "ميزات توثيق مدمجة لوكالات التوظيف تشمل سجلات التدقيق والتقارير القابلة للتصدير.",
 recruitmentSolution3Benefit: "توثيق جاهز للتدقيق",
 recruitmentCtaTitle: "مستعد لتبسيط مدفوعات المقاولين؟",
 recruitmentCtaDesc: "انضم لوكالات التوظيف التي تستخدم بالفعل Flip لدفع المقاولين حول العالم",
 recruitmentGetStartedToday: "ابدأ اليوم",
 
 // E-commerce Page
 ecommerceBuiltFor: "التجارة الإلكترونية",
 ecommerceHeroTitle: "ادفع للموردين والبائعين عالمياً",
 ecommerceHeroDesc: "Flip يسهل على شركات التجارة الإلكترونية دفع الموردين والبائعين والشركاء حول العالم. مدفوعات احترافية بدون التعقيد.",
 ecommerceStartPaying: "ابدأ دفع الموردين",
 ecommerceSeeUseCases: "شاهد حالات استخدام التجارة الإلكترونية",
 ecommerceBusinessesCount: "شركات التجارة الإلكترونية",
 ecommerceFasterPayment: "معالجة دفع أسرع",
 ecommerceAvgPaymentTime: "متوسط وقت الدفع",
 ecommerceCountriesSupported: "الدول المدعومة",
 ecommercePaymentProcessing: "معالجة الدفع",
 
 // Freelancer Platforms Page
 freelancerPlatformsBuiltFor: "منصات المستقلين",
 freelancerPlatformsHeroTitle: "ادفع للمستقلين عالمياً على نطاق واسع",
 freelancerPlatformsHeroDesc: "Flip يمكّن منصات المستقلين من دفع آلاف المستقلين حول العالم. البنية التحتية لمدفوعات المستقلين الضخمة.",
 freelancerPlatformsStartPaying: "ابدأ دفع المستقلين",
 freelancerPlatformsSeeUseCases: "شاهد حالات استخدام المنصات",
 freelancerPlatformsPlatformsCount: "منصات المستقلين",
 freelancerPlatformsFasterPayment: "معالجة دفع أسرع",
 freelancerPlatformsAvgPaymentTime: "متوسط وقت الدفع",
 freelancerPlatformsCountriesSupported: "الدول المدعومة",
 freelancerPlatformsPaymentProcessing: "معالجة الدفع",
 
 // UAE Hub - Arabic
 uaeHeroTitle: "ادفع للمقاولين في الخارج من الإمارات — برقم الهاتف",
 uaeHeroSubtitle: "يتلقى المقاولون العملة المحلية في حسابهم المصرفي. USDC تحت الغطاء (اختياري). لا حاجة لمحفظة.",
 uaePrimaryCta: "تقدير التوفير في التكاليف",
 uaeSecondaryCta: "سجّل مجاناً",
 uaeHowItWorksTitle: "كيف يعمل",
 uaeHowItWorksStep1Title: "أضف المقاول",
 uaeHowItWorksStep1Desc: "أدخل رقم هاتفهم والمبلغ. لا حاجة لتفاصيل البنك.",
 uaeHowItWorksStep2Title: "نحن نتولى التحويل",
 uaeHowItWorksStep2Desc: "نقوم بتحويل AED إلى USDC ثم إلى عملتهم المحلية.",
 uaeHowItWorksStep3Title: "يتلقون الأموال",
 uaeHowItWorksStep3Desc: "يصل الأموال إلى حسابهم المصرفي بالعملة المحلية.",
 uaeWhyOverpayTitle: "لماذا تدفع الفرق أكثر",
 uaeWhyOverpayDesc: "عند إرسال المال دولياً، تكلفتك الحقيقية هي الرسوم + فرق سعر الصرف. معظم البنوك ومقدمي الخدمات يضيفون هامشاً خفياً على سعر الصرف — عادة 1-4% — بالإضافة إلى الرسوم المعلنة.",
 uaePopularCorridors: "الممرات الشائعة",
 uaeResourcesTitle: "الموارد",
 uaeFaqPreview: "الأسئلة الشائعة",
 uaeTrustCopy: "تقديرات إرشادية بناءً على التكاليف الإجمالية النموذجية (الرسوم + فرق سعر الصرف). تختلف الفعلية حسب الممر/المزود.",
 
 // UAE Resources Hub - Arabic
 uaeResourcesHubTitle: "موارد الإمارات",
 uaeResourcesHubDesc: "أدوات وأدلة لمساعدتك على فهم وتقليل تكاليف الدفع الخارجية",
 uaeFxLeakCalculator: "حاسبة تسرب سعر الصرف",
 uaeFxLeakCalculatorDesc: "اكتشف مقدار الخسارة من هامش سعر الصرف الخفي",
 uaePayoutChecklist: "قائمة مراجعة الدفع للمقاولين",
 uaePayoutChecklistDesc: "قائمة مراجعة خطوة بخطوة لتحسين مدفوعات المقاولين",
 uaeBankDeductions: "شرح خصومات البنك",
 uaeBankDeductionsDesc: "فهم لماذا يتلقى المستلمون أقل مما أرسلت",
 uaeCorridorGuides: "أدلة الممرات",
 uaeCorridorGuidesDesc: "أدلة مفصلة لإرسال المال إلى دول محددة",
 uaeFaqLink: "الأسئلة الشائعة",
 uaeFaqLinkDesc: "إجابات على الأسئلة الشائعة حول مدفوعات المقاولين",
 
 // FX Leak Checker - Arabic
 fxLeakTitle: "فاحص تسرب سعر الصرف",
 fxLeakSubtitle: "اكتشف مقدار خسارتك من هامش سعر الصرف الخفي في تحويلاتك الدولية",
 fxLeakAedSent: "AED المرسل",
 fxLeakAedSentPlaceholder: "مثال: 10,000",
 fxLeakAmountReceived: "المبلغ المستلم (عملة أجنبية)",
 fxLeakAmountReceivedPlaceholder: "مثال: 2,500",
 fxLeakCurrency: "عملة المستلم",
 fxLeakMidMarketRate: "سعر السوق الوسيط",
 fxLeakMidMarketRatePlaceholder: "مثال: 4.10",
 fxLeakMidMarketRateHelp: "ابحث في Google عن 'AED to [العملة]' للحصول على السعر الحالي",
 fxLeakVisibleFee: "الرسوم المرئية (AED، اختياري)",
 fxLeakVisibleFeePlaceholder: "مثال: 25",
 fxLeakCalculate: "احسب تسربي",
 fxLeakResults: "نتائجك",
 fxLeakEffectiveRate: "سعرك الفعلي",
 fxLeakImpliedSpread: "الهامش الضمني",
 fxLeakHiddenCost: "تكلفة سعر الصرف الخفية",
 fxLeakAllInCost: "التكلفة الإجمالية",
 fxLeakSaveResults: "احفظ نتائجي",
 fxLeakEmailRequired: "أدخل بريدك الإلكتروني لحفظ النتائج",
 fxLeakCompanyRequired: "اسم الشركة",
 fxLeakDisclaimer: "هذه الحاسبة توفر تقديرات إرشادية. النتائج الفعلية قد تختلف بناءً على توقيت التحويل، رسوم البنك الوسيط، والعوامل الأخرى.",
 
 // Cost Savings Estimate - Arabic
 costEstimateTitle: "تقدير التوفير في التكاليف",
 costEstimateSubtitle: "اكتشف مقدار التوفير المحتمل على مدفوعات المقاولين في الخارج",
 
 // Corridor Pages - Arabic
 corridorIndiaTitle: "أرسل المال من الإمارات إلى الهند",
 corridorIndiaDesc: "دليل كامل لدفع المقاولين في الهند من الإمارات",
 corridorPakistanTitle: "أرسل المال من الإمارات إلى باكستان",
 corridorPakistanDesc: "دليل كامل لدفع المقاولين في باكستان من الإمارات",
 corridorPhilippinesTitle: "أرسل المال من الإمارات إلى الفلبين",
 corridorPhilippinesDesc: "دليل كامل لدفع المقاولين في الفلبين من الإمارات",
 corridorUkEuropeTitle: "أرسل المال من الإمارات إلى المملكة المتحدة/أوروبا",
 corridorUkEuropeDesc: "دليل كامل لدفع المقاولين في المملكة المتحدة وأوروبا من الإمارات",
 corridorCommonMethods: "الطرق الشائعة",
 corridorCostDrivers: "محركات التكلفة",
 corridorVerifyRate: "كيفية التحقق من سعرك",
 corridorMiniChecklist: "قائمة مراجعة سريعة",
 
 // FAQ Page - Arabic
 uaeFaqTitle: "الأسئلة الشائعة عن مدفوعات الإمارات",
 uaeFaqSubtitle: "إجابات على 25 سؤالاً شائعاً حول دفع المقاولين في الخارج من الإمارات",
 
 // CTA Component - Arabic
 uaeCtaTitle: "مستعد لتقليل تكاليف المدفوعات؟",
 uaeCtaDescription: "اكتشف مقدار ما يمكنك توفيره في مدفوعات المقاولين الخارجيين من الإمارات.",
 
 // Resource Download Gate - Arabic
 uaeDownloadErrorEmail: "يرجى إدخال عنوان بريد إلكتروني صالح",
 uaeDownloadErrorCompanyName: "يرجى إدخال اسم شركتك",
 uaeDownloadSuccess: "التحميل جاهز!",
 uaeDownloadSuccessDescription: "يبدأ التحميل الآن.",
 uaeDownloadButton: "تحميل المورد",
 uaeDownloadTitle: "احصل على موردك المجاني",
 uaeDownloadDescription: "أدخل بياناتك لتحميل {resource}",
 uaeDownloadEmail: "البريد الإلكتروني للعمل",
 uaeDownloadCompanyName: "اسم الشركة",
 uaeDownloadCancel: "إلغاء",
 uaeDownloadSubmitting: "جاري المعالجة...",
 uaeDownloadNow: "تحميل الآن",
 uaeDownloadErrorSubmitFailed: "فشل التحميل",
 uaeDownloadErrorTryAgain: "يرجى المحاولة مرة أخرى بعد لحظة.",
 
 // UAE Corridor Card
 uaeCorridorFees: "الرسوم",
 uaeCorridorSpread: "الفارق",
 uaeCorridorTime: "الوقت",
 uaeCorridorLearnMore: "اعرف المزيد",

 // Homepage — Hero
 homeHeroLabel: "مدفوعات العملات المستقرة بالجملة",
 homeHeroTitle1: "ادفع لفريقك بالكامل — في معاملة واحدة",
 homeHeroSubtitle: "مدفوعات العملات المستقرة بالجملة للشركات. أضف المقاولين برقم الهاتف، أرسل دفعات جماعية في ثوانٍ.",
 homeHeroButton: "احصل على تحويلاتك المجانية",
 homeHeroDemoButton: "احجز عرضاً توضيحياً",
 headerLogin: "تسجيل الدخول",
 headerSignup: "تسجيل الدخول / إنشاء حساب",
 homeHeroLink: "شاهد كيف يعمل",
 homeHeroFootnote: "",

 // Homepage — Differentiator Strip
 diffTitle1: "دفعات جماعية في ثوانٍ",
 diffDesc1: "أرسل لفريقك بالكامل في معاملة واحدة. لا مزيد من التحويلات الفردية أو المتابعات اليدوية.",
 diffTitle2: "لا منصة لفريقك للانضمام إليها",
 diffDesc2: "يستلم المقاولون USDC برقم هاتفهم — فورًا.",
 diffTitle3: "أصلي بـ USDC، الأول في المنطقة",
 diffDesc3: "مصمم للممرات حيث USDC هو ما يريد فريقك استلامه فعلاً.",

 // Homepage — Mid-page Demo CTA
 demoCTATitle: "تدفع لأكثر من 20 شخصاً، أو تدير مدفوعات فريق عالمي؟",
 demoCTASub: "احجز مكالمة 15 دقيقة. سنستعرض إعدادك المحدد، ونجيب على أسئلة الإعداد، ونوضح لك كيف يتعامل Flip مع الدفعات الجماعية على نطاق واسع.",
 demoCTAButton: "احجز عرضاً توضيحياً",

 // Homepage — Trust Block
 trustSignal1: "تُدار بواسطة Flip Company AS",
 trustSignal2: "مصمم لمدفوعات الأعمال العالمية",

 // Homepage — Problem Section
 problemTitle: "دفع فريق مقاولين عالمي معطّل",
 problemSubtitle: "كل طريقة لها عيوب. التحويلات البنكية تستنزف الرسوم، منصات EOR تحبسك، ومحافظ العملات الرقمية تضع التعقيد على فريقك.",
 problemCard1Title: "التحويلات البنكية",
 problemCard1Item1: "25-50$ لكل مقاول لكل تحويل",
 problemCard1Item2: "3-5 أيام عمل للتسليم",
 problemCard1Item3: "رفض بنكي وتوجيه فاشل",
 problemCard1Item4: "هوامش صرف مخفية 1-4%",
 problemCard2Title: "منصات EOR (Deel, Remote)",
 problemCard2Item1: "300-500$/شهر لكل مقاول",
 problemCard2Item2: "أسابيع من التسجيل لكل شخص",
 problemCard2Item3: "محصور في خطط سنوية",
 problemCard3Title: "محافظ العملات الرقمية",
 problemCard3Item1: "المقاولون يحمّلون تطبيقات ويديرون عبارات الاسترداد",
 problemCard3Item2: "تحويل ذاتي للعملة المحلية",
 problemCard3Item3: "عبء الدعم يقع عليك",
 problemClosing: "Flip هو السكة الخفيفة للفرق التي تحتاج فقط لدفع الناس، بسرعة.",

 // Homepage — How It Works
 howItWorksSectionTitle: "ثلاث خطوات. معاملة واحدة.",
 hiwStep1Title: "أضف فريقك",
 hiwStep1Desc: "رفع CSV أو واحداً تلو الآخر. فقط الاسم ورقم الهاتف — بدون عناوين محافظ، بدون رسائل دعوة.",
 hiwStep2Title: "حدد المبالغ",
 hiwStep2Desc: "حدد أجر كل مقاول بالدولار. احفظ كقالب للمدفوعات المتكررة.",
 hiwStep3Title: "أرسل الدفعة",
 hiwStep3Desc: "توقيع واحد، معاملة واحدة، الجميع يُدفع له في ثوانٍ. تتبع التسليم في الوقت الفعلي.",
 hiwCardTitle: "كيف يعمل Flip",
 hiwStepLabel: "خطوة",
 hiwStatusDelivered: "تم التسليم",
 hiwStatusPending: "قيد الانتظار",
 hiwStatusReturned: "مُرتجع",
 hiwFootnote: "من التسجيل إلى أول دفعة: عادةً 1-2 يوم عمل.",
 hiwCorridors: "يعمل عبر ممرات دفع متعددة.",

 // Homepage — Why Flip
 whyFlipSectionTitle: "لماذا تختار الفرق Flip",
 whyFlip1Title: "لا تسجيل للمستلمين",
 whyFlip1Desc: "رقم الهاتف يكفي — أرسل USDC في ثوانٍ.",
 whyFlip1Label1: "المستلم",
 whyFlip1Status: "جاهز للاستلام",
 whyFlip2Title: "تسوية في ثوانٍ",
 whyFlip2Desc: "تجاوز تأخير البنوك 3-5 أيام. USDC يُسوّى على السلسلة في ثوانٍ.",
 whyFlip2Wire: "تحويل بنكي",
 whyFlip2FlipSpeed: "ثوانٍ",
 whyFlip3Title: "معاملة واحدة، كل الفريق",
 whyFlip3Desc: "اجمع كامل المدفوعات في معاملة واحدة.",
 whyFlip3Recipients: "المستلمون",
 whyFlip3Total: "إجمالي الدفعة",
 whyFlip3Sent: "تم الإرسال",
 whyFlip4Title: "رسوم أقل",
 whyFlip4Desc: "لا رسوم منصة لكل مقاول. لا رسوم تحويل. فقط نسبة ثابتة.",
 whyFlip4WireFee: "رسوم التحويل (لكل شخص)",
 whyFlip4PlatformFee: "رسوم منصة EOR",
 whyFlip4FlipFee: "رسوم Flip",

 // Homepage — FAQ
 homeFaqTitle: "الأسئلة الشائعة",
 homeFaq1Q: "ما هو Flip؟",
 homeFaq1A: "Flip منصة دفع B2B تتيح للشركات دفع المقاولين والمستقلين والفرق عن بُعد في أكثر من 100 دولة عبر إرسال USDC — يستلم المستلم الأموال بعملته المحلية، عادةً خلال أقل من 5 دقائق.",
 homeFaq2Q: "هل يمكن للمستلمين في أي دولة استلام USDC؟",
 homeFaq2A: "نعم. يمكن لأي شخص لديه رقم هاتف استلام USDC من Flip في أكثر من 100 دولة — دون الحاجة إلى حساب مصرفي.",
 homeFaq3Q: "كم يستغرق دفع USDC عبر Flip؟",
 homeFaq3A: "تُسوّى معظم المدفوعات عبر الحدود في أقل من 5 دقائق، مقارنة بـ 1-5 أيام عمل لتحويلات SWIFT المصرفية التقليدية.",
 homeFaq4Q: "ما الدول التي يدعمها Flip؟",
 homeFaq4A: "يدعم Flip المدفوعات للمقاولين والمستقلين في أكثر من 100 دولة حول العالم، مع التسوية بالعملة المحلية مباشرة إلى الحساب البنكي للمستلم.",
 homeFaq5Q: "ما هي الأسعار؟",
 homeFaq5A: "يتقاضى Flip نسبة ثابتة لكل معاملة — تبدأ من 2% للحجم العادي. بدون رسوم إعداد أو حد أدنى شهري أو رسوم منصة لكل مقاول.",
 homeFaq6Q: "كيف يختلف Flip عن Deel أو Remote؟",
 homeFaq6A: "Deel و Remote منصات EOR تتقاضى 300-500$/شهر لكل مقاول وتتطلب أسابيع من التسجيل. Flip سكة دفع — أضف المقاولين برقم الهاتف، ادفع في ثوانٍ.",

 // Homepage — Testimonial
 homeTestimonialQuote: "المدفوعات تعمل الآن ببساطة — متابعات أقل وعمليات إرجاع أقل.",
 homeTestimonialAuthor: "مدير مالي",
 homeTestimonialCompany: "شركة خدمات",

 // Homepage — Final CTA
 homeFinalCtaTitle: "مستعد لدفع فريقك في ثوانٍ؟",
 homeFinalCtaFlip: "Flip",
 homeFinalCtaSubtitle: "إنشاء حساب مجاني. لا حاجة لبطاقة ائتمان.",
 homeFinalCtaPlaceholder: "أدخل بريدك الإلكتروني للعمل",
 homeFinalCtaButton: "ابدأ الدفع بـ USDC",
 homeFinalCtaDemoButton: "أو احجز عرضاً توضيحياً",
 homeFinalCtaDisclaimer: "إنشاء حساب مجاني. لا حاجة لبطاقة ائتمان.",
 homeFinalCtaPlaybook: "لست جاهزاً؟ احصل على دليل مدفوعات المقاولين",
 homeFinalCtaTeamSize: "حجم الفريق",
 homeFinalCtaSend: "إرسال",

 // Homepage — Use Cases card content
 realBusinessUseCases: "مصمم لفرق بكل الأحجام",
 useCasesDescription: "من متاجر التطوير إلى المؤسسات العالمية، Flip يتعامل مع مدفوعات USDC الجماعية بأي حجم — من 5 مقاولين إلى 5,000.",
 useCaseTechTitle: "متاجر التطوير والوكالات",
 useCaseTechDesc: "ادفع لـ 30 مقاولاً عبر 12 دولة كل جمعة. رفع CSV، معاملة واحدة، انتهى.",
 useCaseAgencyTitle: "وكالات المحتوى والمبدعين",
 useCaseAgencyDesc: "ادفع للكتّاب والمحررين والمصممين في أمريكا اللاتينية وأوروبا الشرقية وجنوب شرق آسيا.",
 useCaseRemoteTitle: "عمليات التجارة الإلكترونية",
 useCaseRemoteDesc: "ادفع لفريق المساعدين الافتراضيين والمصممين المستقلين ومقاولي الدعم بدون رسوم تحويل.",
 useCaseEnterpriseTitle: "المؤسسات والعمليات العالمية",
 useCaseEnterpriseDesc: "ادفع لفرق موزعة عبر مناطق متعددة بدورة مدفوعات واحدة. سير عمل موافقة مخصص، دعم مخصص، وتكامل مباشر مع مجموعتك المالية.",

 // Homepage — Trust Block
 trustGlobalLine: "موثوق من فرق في أكثر من 40 دولة",
 trustCoinmenaContext: "Flip Company AS — مدفوعات عملات مستقرة عالمية للأعمال",
 trustNbxContext: "مصمم لمدفوعات الأعمال العالمية",

 // Enterprise page
 enterpriseHeroTitle: "مدفوعات المقاولين مصممة لحجم المؤسسات",
 enterpriseHeroSub: "ادفع لفرق موزعة عبر مناطق متعددة بدورة مدفوعات واحدة. سير عمل موافقة مخصص، دعم مخصص، وتكامل مباشر مع مجموعتك المالية.",

 // Homepage — Comparison Table
 compTitle: "كيف يُقارن Flip",
 compWireHeader: "التحويلات البنكية",
 compEorHeader: "Deel / EOR",
 compSetupTime: "وقت الإعداد",
 compFlipSetup: "دقائق",
 compWireSetup: "أيام",
 compEorSetup: "أسابيع",
 compRecipientOnboarding: "تسجيل المستلم",
 compFlipOnboarding: "لا شيء — رقم الهاتف",
 compWireOnboarding: "تفاصيل بنكية مطلوبة",
 compEorOnboarding: "تسجيل كامل في المنصة",
 compPaymentSpeed: "سرعة الدفع",
 compFlipSpeed: "ثوانٍ",
 compWireSpeed: "3-5 أيام",
 compEorSpeed: "1-5 أيام",
 compPerContractorCost: "تكلفة لكل مقاول",
 compFlipCost: "2% لكل معاملة",
 compWireCost: "25-50$ لكل معاملة",
 compEorCost: "300-500$/شهر",
 compBatchPayments: "مدفوعات جماعية",
 compKybFriction: "احتكاك KYB",
 compFlipKyb: "قياسي — 1-2 يوم",
 compWireKyb: "يختلف حسب البنك",
 compEorKyb: "معقد — أسابيع",
 compCurrencyDelivered: "العملة المسلّمة",
 compFlipCurrency: "USDC",
 compWireCurrency: "عملة محلية",
 compEorCurrency: "عملة محلية",
 compBestFor: "الأفضل لـ",
 compFlipBestFor: "السرعة، النطاق، التكلفة المنخفضة",
 compWireBestFor: "تحويلات لمرة واحدة",
 compEorBestFor: "توظيف كامل",
 }
};

export const t = (key: string, language: 'en' | 'ar'): string => {
 const keys = key.split('.');

 // Try requested language first
 let value: unknown = translations[language];
 for (const k of keys) {
 if (value && typeof value === 'object') {
 value = (value as Record<string, unknown>)[k];
 } else {
 value = undefined;
 break;
 }
 }
 if (typeof value === 'string') return value;

 // Fallback to English
 if (language !== 'en') {
 let enValue: unknown = translations['en'];
 for (const k of keys) {
 if (enValue && typeof enValue === 'object') {
 enValue = (enValue as Record<string, unknown>)[k];
 } else {
 enValue = undefined;
 break;
 }
 }
 if (typeof enValue === 'string') return enValue;
 }

 return key;
};
